<template>
    <div class="kp">

        <!-- ════════════════════ DASHBOARD HEADER ════════════════════ -->
        <div class="kp-dash-header">
            <div class="kp-dash-header-top">
                <div>
                    <div class="kp-eyebrow">FINANZAS · KPI DASHBOARD</div>
                    <h1 class="kp-title">KPI · Indicadores</h1>
                </div>
                <div class="kp-header-actions">
                    <div class="kp-stat-pill">
                        <i class="fa-solid fa-calendar"></i>
                        <strong>{{ anioSeleccionado }}</strong>
                        <span>· {{ textoFechaActual }}</span>
                    </div>
                    <div class="kp-stat-pill">
                        <i class="fa-solid fa-building"></i>
                        <strong>{{ empresaSeleccionada.nombre }}</strong>
                    </div>
                    <div class="kp-stat-pill" :class="datosResumenMes.total >= 0 ? 'kp-stat-pill--success' : 'kp-stat-pill--danger'" v-if="datosResumenMes && datosResumenMes.total !== undefined">
                        <i :class="datosResumenMes.total >= 0 ? 'fa-solid fa-arrow-trend-up' : 'fa-solid fa-arrow-trend-down'"></i>
                        <strong>{{ formatoEspanol(datosResumenMes.total) }} €</strong>
                        <span>balance</span>
                    </div>
                    <button class="kp-btn" @click="$router.push('/kpi-gastos')">
                        <i class="fa-solid fa-gear"></i>
                        <span>Gestionar gastos</span>
                    </button>
                </div>
            </div>
        </div>

        <div>
            <div style="text-align: center; margin-bottom: 20px;" v-if="diasFijados.length > 0">
                <b-button @click="desfijarTodos()">Desfijar Todos</b-button>
            </div>
            <b-row>
                <b-col
                    v-for="(dia,index) in diasFijados"
                    :key="dia.id"
                    md="4"
                    sm="4"
                >
                    <b-card :title="'Día '+ dia.diaNumero + ' - ' + dia.diaSemana" >
                        <b-card-text style="margin-bottom: 0px;">
                            <div style="display: flex; justify-content: space-between;">
                                <b>£ {{ dia.total }}</b>
                                <b>{{ dia.totalEur }} €</b>
                            </div>
                        </b-card-text>

                        <b-card-text style="margin-top: 20px;">
                            <!--<span v-b-toggle="'ordenes-' + index" v-if="dia.ordenes.total != 0" :class="{'boton-detalles': dia.ordenes.total != 0}"><i v-if="dia.ordenes.total != 0" class="fa-solid fa-arrows-up-down"></i> Ordenes ({{ dia.ordenes.items.length }}): <b>£ {{ dia.ordenes.total }}</b><br></span>
                            <b-collapse :id="'ordenes-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.ordenes.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.name }} - {{ item.current_total_price }}
                                </p>
                            </b-collapse>-->

                            <span v-b-toggle="'facturas-' + index" v-if="dia.facturasPositivas.total != 0" :class="{'boton-detalles': dia.facturasPositivas.total != 0}" ><i v-if="dia.facturasPositivas.total != 0" class="fa-solid fa-arrows-up-down"></i> Facturas ({{ dia.facturasPositivas.items.length }}): <b>{{ dia.facturasPositivas.total }} €</b><br></span>
                            <b-collapse :id="'facturas-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.facturasPositivas.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.codigo }} - {{ item.total }}
                                </p>
                            </b-collapse>

                            <hr style="margin:0px">
                            <span v-b-toggle="'envios-' + index" v-if="dia.envios.total != 0" :class="{'boton-detalles': dia.envios.total != 0}" ><i v-if="dia.envios.total != 0" class="fa-solid fa-arrows-up-down"></i> Envios ({{ dia.envios.items.length }}): <b>{{ dia.envios.total }} €</b><br></span>
                            <b-collapse :id="'envios-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.envios.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.order_num }} - {{ item.full_data.service }}
                                </p>
                            </b-collapse>

                            <span v-b-toggle="'proveedores-' + index" v-if="dia.proveedores.total != 0" :class="{'boton-detalles': dia.proveedores.total != 0}" ><i v-if="dia.proveedores.total != 0" class="fa-solid fa-arrows-up-down"></i> Proveedores ({{ dia.proveedores.items.length }}): <b>{{ dia.proveedores.total }} €</b><br></span>
                            <b-collapse :id="'proveedores-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.proveedores.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.proveedor }} - {{ item.total }}
                                </p>
                            </b-collapse>

                            <span v-b-toggle="'facturasNegativas-' + index" v-if="dia.facturasNegativas.total != 0" :class="{'boton-detalles': dia.facturasNegativas.total != 0}" ><i v-if="dia.facturasNegativas.total != 0" class="fa-solid fa-arrows-up-down"></i> Facturas ({{ dia.facturasNegativas.items.length }}): <b>{{ dia.facturasNegativas.total }} €</b><br></span>
                            <b-collapse :id="'facturasNegativas-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.facturasNegativas.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.codigo }} - {{ item.total }}
                                </p>
                            </b-collapse>

                            <span v-b-toggle="'pagosPuntuales-' + index" v-if="dia.pagosPuntualesDia.total != 0" :class="{'boton-detalles': dia.pagosPuntualesDia.total != 0}" ><i v-if="dia.pagosPuntualesDia.total != 0" class="fa-solid fa-arrows-up-down"></i> Puntuales ({{ dia.pagosPuntualesDia.items.length }}): <b>{{ dia.pagosPuntualesDia.total }} €</b><br></span>
                            <b-collapse :id="'pagosPuntuales-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.pagosPuntualesDia.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.nombre }} - {{ item.descripcion }} - {{ item.precio }}
                                </p>
                            </b-collapse>

                            <span v-b-toggle="'pagosMensuales-' + index" v-if="dia.pagosMensuales.total != 0" :class="{'boton-detalles': dia.pagosMensuales.total != 0}" ><i v-if="dia.pagosMensuales.total != 0" class="fa-solid fa-arrows-up-down"></i> Mensuales ({{ dia.pagosMensuales.items.length }}): <b>{{ dia.pagosMensuales.total }} €</b><br></span>
                            <b-collapse :id="'pagosMensuales-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.pagosMensuales.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.nombre }} - {{ item.descripcion }} - {{ item.precio }}
                                </p>
                            </b-collapse>

                            <span v-b-toggle="'pagosAnuales-' + index" v-if="dia.pagosAnuales.total != 0" :class="{'boton-detalles': dia.pagosAnuales.total != 0}" ><i v-if="dia.pagosAnuales.total != 0" class="fa-solid fa-arrows-up-down"></i> Anuales ({{ dia.pagosAnuales.items.length }}): <b>{{ dia.pagosAnuales.total }} €</b><br></span>
                            <b-collapse :id="'pagosAnuales-' + index" role="tabpanel">
                                <p v-for="(item,index) in dia.pagosAnuales.items" :key="index" style="margin-bottom: 0px; margin-left: 15px;">
                                    {{ item.nombre }} - {{ item.descripcion }} - {{ item.precio }}
                                </p>
                            </b-collapse>
                        </b-card-text>

                    </b-card>

                </b-col>
            </b-row>
        </div>
        <div v-if="false" class="filtros-container">
            <div class="grupo-empresa">
                <b-button-group>
                    <b-button 
                    @click="cambiarEmpresaSeleccionada('Todas')" 
                    :variant="empresaSeleccionada.nombre === 'Todas' ? 'warning' : 'secondary'"
                    >
                    Todas
                    </b-button>
                    <b-button 
                    @click="cambiarEmpresaSeleccionada('Harber London')" 
                    :variant="empresaSeleccionada.nombre === 'Harber London' ? 'primary' : 'secondary'"
                    >
                    Harber
                    </b-button>
                    <b-button 
                    @click="cambiarEmpresaSeleccionada('Craft Lab')" 
                    :variant="empresaSeleccionada.nombre === 'Craft Lab' ? 'info' : 'secondary'"
                    >
                    CraftLab
                    </b-button>
                </b-button-group>
            </div>

            <div class="grupo-gestion">
                <b-button variant="outline-dark" @click="$router.push('/kpi-gastos');">
                    Gestionar Gastos
                </b-button>
            </div>
        </div>

        <div class="anio-selector-container">
            <div class="anio-selector">
                <button
                    v-for="anio in aniosDisponibles"
                    :key="anio"
                    :class="['anio-btn', { active: anioSeleccionado === anio }]"
                    @click="cambiarAnio(anio)"
                >
                    {{ anio }}
                </button>
            </div>
        </div>

        <div class="meses-grid">
            <div
                v-for="(dato, idx) in mesesUltimos12"
                :key="idx"
                :class="['mes-card', { 'mes-card--selected': mesSeleccionado.value == dato.value, 'mes-card--positivo': dato.importe > 0, 'mes-card--negativo': dato.importe < 0 }]"
                @click="clickMes(dato)"
            >
                <div class="mes-card__nombre">{{ dato.mes }}</div>
                <div class="mes-card__importe" :class="{ 'text-success': dato.importe > 0, 'text-danger': dato.importe < 0 }">
                    {{ formatoEspanol(dato.importe) }} €
                </div>
            </div>
        </div>

        <div v-if="!cargando">

            <div class="empresa-selector-container">
                <div class="empresa-selector">
                    <button
                        :class="['empresa-btn', { active: empresaSeleccionada.nombre === 'Todas' }]"
                        @click="cambiarEmpresaSeleccionada('Todas')"
                    >
                        Todas
                    </button>
                    <button
                        :class="['empresa-btn empresa-btn--harber', { active: empresaSeleccionada.nombre === 'Harber London' }]"
                        @click="cambiarEmpresaSeleccionada('Harber London')"
                    >
                        Harber
                    </button>
                    <button
                        :class="['empresa-btn empresa-btn--craft', { active: empresaSeleccionada.nombre === 'Craft Lab' }]"
                        @click="cambiarEmpresaSeleccionada('Craft Lab')"
                    >
                        CraftLab
                    </button>
                </div>
            </div>

            <b-row class="resumen-row">
                <b-col cols="12" lg="6">
                    <div class="resumen-card">
                        <div class="resumen-card__header">
                            <h4 class="resumen-card__title">Resumen de {{ textoFechaActual }}</h4>
                            <button class="icon-btn" @click="toggleDesglosarTodos(!mostrarTodos)">
                                <i v-if="!mostrarTodos" class="fa-solid fa-eye"></i>
                                <i v-else class="fa-solid fa-eye-slash"></i>
                            </button>
                        </div>
                        <div class="resumen-card__body">
                            <div class="resumen-cols">
                                <div class="resumen-col resumen-col--gastos">
                                    <h5 class="resumen-col__title"><i class="fa-solid fa-arrow-trend-down"></i> Gastos</h5>
                                    <div class="resumen-col__item"><span>Media diaria</span><strong>{{ formatoEspanol(datosResumenMes.gastoMedioDiaria) }} €</strong></div>
                                    <div class="resumen-col__item"><span>Total</span><strong>{{ formatoEspanol(datosResumenMes.gastoTotal) }} €</strong></div>
                                    <div class="resumen-col__item"><span>Facturas</span><strong>{{ formatoEspanol(datosResumenMes.gastoFacturas) }} €</strong></div>
                                </div>
                                <div class="resumen-col resumen-col--ganancias">
                                    <h5 class="resumen-col__title"><i class="fa-solid fa-arrow-trend-up"></i> Ganancias</h5>
                                    <div class="resumen-col__item"><span>Media diaria</span><strong>{{ formatoEspanol(datosResumenMes.gananciaMediaDiaria) }} €</strong></div>
                                    <div class="resumen-col__item"><span>Total</span><strong>{{ formatoEspanol(datosResumenMes.gananciaTotalDiaria) }} €</strong></div>
                                    <div class="resumen-col__item"><span>Facturas</span><strong>{{ formatoEspanol(datosResumenMes.gananciaFacturas) }} €</strong></div>
                                </div>
                            </div>
                            <div class="resumen-total" :class="{ 'resumen-total--positivo': datosResumenMes.total > 0, 'resumen-total--negativo': datosResumenMes.total < 0 }">
                                <span>Balance</span>
                                <strong>{{ formatoEspanol(datosResumenMes.total) }} €</strong>
                            </div>
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" lg="6">
                    <div class="resumen-card">
                        <div class="resumen-card__header">
                            <h4 class="resumen-card__title">Resumen categorías</h4>
                            <div class="resumen-card__actions">
                                <button class="icon-btn" @click="mostrarCategoriasLista = !mostrarCategoriasLista">
                                    <i v-if="mostrarCategoriasLista" class="fa-solid fa-chart-pie"></i>
                                    <i v-else class="fa-solid fa-list"></i>
                                </button>
                                <button class="icon-btn icon-btn--warning" @click="openModalCategorias()">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                </button>
                            </div>
                        </div>
                        <div class="resumen-card__body">
                            <div v-if="mostrarCategoriasLista">
                                <div class="categorias-grid">
                                    <div v-for="(item, index) in categoriasCalculadas" :key="index" class="categoria-item boton-detalles" @click="mostrarPagosCategoria(item)">
                                        <span class="categoria-item__nombre">{{ item.categoria }}</span>
                                        <span class="categoria-item__precio">{{ formatoEspanol(item.precio) }} €</span>
                                    </div>
                                </div>
                                <div class="resumen-total">
                                    <span>Total categorías</span>
                                    <strong>{{ formatoEspanol(totalCategorias) }} €</strong>
                                </div>
                            </div>
                            <div v-else>
                                <apexchart
                                    type="pie"
                                    height="300"
                                    :options="chartCategorias"
                                    :series="seriesCategorias"
                                />
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="dias-grid">
                <div
                    v-for="(dia, index) in dias"
                    :key="index"
                    class="dia-wrapper"
                >
                    <div
                        v-if="!dia.empty"
                        :class="['dia-card', { 'dia-card--positivo': !dia.futuro && dia.total > 0, 'dia-card--negativo': !dia.futuro && dia.total < 0, 'dia-card--futuro': dia.futuro, 'dia-card--neutro': !dia.futuro && dia.total == 0 }]"
                    >
                        <div class="dia-card__header">
                            <span class="boton-detalles dia-card__icon" @click="toggleFijar(index)">
                                <i v-if="!dia.fijado" class="fa-solid fa-link"></i>
                                <i v-else class="fa-solid fa-link-slash"></i>
                            </span>
                            <span class="dia-card__titulo">{{ dia.diaNumero }} <small>{{ dia.diaSemana }}</small></span>
                            <span class="boton-detalles dia-card__icon" @click="toggleDesglosar(index)">
                                <i v-if="!dia.desglosar" class="fa-solid fa-eye"></i>
                                <i v-else class="fa-solid fa-eye-slash"></i>
                            </span>
                        </div>

                        <div class="dia-card__importes">
                            <span>£ {{ dia.total }}</span>
                            <span>{{ dia.totalEur }} €</span>
                        </div>

                        <div v-if="dia.desglosar" class="dia-card__desglose">
                            <span v-if="dia.ingresos.total != 0" class="boton-detalles dia-card__linea" @click="mostrarIngresos(dia.ingresos, dia.diaSemana + ' ' + dia.diaNumero)"><i class="fa-solid fa-circle-info"></i> Ingresos: <b>£ {{ dia.ingresos.total }}</b></span>
                            <span v-if="dia.facturasPositivas.total != 0" class="boton-detalles dia-card__linea" @click="mostrarFacturas(dia.facturasPositivas, dia.diaSemana + ' ' + dia.diaNumero)"><i class="fa-solid fa-circle-info"></i> Facturas: <b>{{ dia.facturasPositivas.total }} €</b></span>
                            <div class="dia-card__separator"></div>
                            <span v-if="dia.envios.total != 0" class="boton-detalles dia-card__linea" @click="mostrarEnvios(dia.envios, dia.diaSemana + ' ' + dia.diaNumero)"><i class="fa-solid fa-circle-info"></i> Envios: <b>{{ dia.envios.total }} €</b></span>
                            <span v-if="dia.proveedores.total != 0" class="boton-detalles dia-card__linea" @click="mostrarProveedores(dia.proveedores, dia.diaSemana + ' ' + dia.diaNumero)"><i class="fa-solid fa-circle-info"></i> Proveedores: <b>{{ dia.proveedores.total }} €</b></span>
                            <span v-if="dia.facturasNegativas.total != 0" class="boton-detalles dia-card__linea" @click="mostrarFacturas(dia.facturasNegativas, dia.diaSemana + ' ' + dia.diaNumero)"><i class="fa-solid fa-circle-info"></i> Facturas: <b>{{ dia.facturasNegativas.total }} €</b></span>
                            <span v-if="dia.pagosPuntualesDia.total != 0" class="boton-detalles dia-card__linea" @click="mostrarPagos(dia.pagosPuntualesDia, dia.diaSemana + ' ' + dia.diaNumero, 'Puntuales')"><i class="fa-solid fa-circle-info"></i> Puntuales: <b>{{ dia.pagosPuntualesDia.total }} €</b></span>
                            <span v-if="dia.pagosMensuales.total != 0" class="boton-detalles dia-card__linea" @click="mostrarPagos(dia.pagosMensuales, dia.diaSemana + ' ' + dia.diaNumero, 'Mensuales')"><i class="fa-solid fa-circle-info"></i> Mensuales: <b>{{ dia.pagosMensuales.total }} €</b></span>
                            <span v-if="dia.pagosAnuales.total != 0" class="boton-detalles dia-card__linea" @click="mostrarPagos(dia.pagosAnuales, dia.diaSemana + ' ' + dia.diaNumero, 'Anuales')"><i class="fa-solid fa-circle-info"></i> Anuales: <b>{{ dia.pagosAnuales.total }} €</b></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="chart-container">
                <apexchart
                    type="area"
                    height="380"
                    :options="chartDiaGastosVentas"
                    :series="seriesDiaGastosVentas"
                ></apexchart>
            </div>

        </div>
        <div v-else class="loading-container">
            <div v-if="errores" class="loading-error">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <span>{{ errores }}</span>
            </div>
            <div v-else class="loading-spinner">
                <b-spinner label="Cargando..." type="grow" variant="primary"></b-spinner>
                <span>Cargando datos...</span>
            </div>
        </div>

        <TablaPdf :items="mesesUltimos12"></TablaPdf>

        <b-modal
            id="modal-detail"
            centered
            :size="sizeModal"
            hide-footer
            modal-class="modal-detail-kpi"
            hide-header
        >
            <div class="modal-kpi">
                <div class="modal-kpi__header">
                    <div>
                        <h4 class="modal-kpi__title">{{ tituloModal }}</h4>
                        <span class="modal-kpi__count">{{ diaDetail.length }} {{ diaDetail.length === 1 ? 'registro' : 'registros' }}</span>
                    </div>
                    <button class="modal-kpi__close" @click="$bvModal.hide('modal-detail')">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <div class="modal-kpi__body">
                    <div
                        v-for="(item, idx) in diaDetail"
                        :key="idx"
                        class="modal-kpi__row"
                    >
                        <div class="modal-kpi__row-info">
                            <span class="modal-kpi__row-name">{{ item[columnasDetails[0].key] || '-' }}</span>
                            <template v-for="(col, cIdx) in columnasDetails.slice(1, -1)">
                                <span v-if="item[col.key]" :key="cIdx" :class="col.key === 'categoria' ? 'modal-kpi__row-cat' : 'modal-kpi__row-desc'">{{ item[col.key] }}</span>
                            </template>
                        </div>
                        <div class="modal-kpi__row-amount" :class="{ 'modal-kpi__row-amount--neg': parseFloat(item[modalAmountField]) < 0 }">
                            {{ formatModalAmount(item[modalAmountField]) }}
                        </div>
                    </div>
                </div>

                <div class="modal-kpi__footer">
                    <span>Total</span>
                    <strong :class="{ 'text-success': modalTotal > 0, 'text-danger': modalTotal < 0 }">{{ formatoEspanol(modalTotal) }} €</strong>
                </div>
            </div>
        </b-modal>

     
    </div>
</template>

<script>
import axios from '@axios'
import vSelect from "vue-select";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";


import TablaPdf from "../../layouts/components/kpi/tablaPdf.vue";

export default {
    components: {
        vSelect,
        DateRangePicker,
        TablaPdf
    },
    data() {
        return {
            mesesDisponibles: this.generarMeses(),
            mesesSeleccionados: this.value || [],
            openAccordions: [],
            form: {
                nombre: '',
                precio: 0,
                iva: 0,
                tipoPrecio: '',
                fecha: '',
                fechaInicio: '',
                fechaFin: '',
                puntual: null,
            },          
            columnasDetails: [
                {
                    key: "descripcion",
                    label: "Descripcion",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "total",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],
            envios: 0,
            ordenes: 0,
            allIngresos: [],
            allEnvios: [],
            allProveedores: [],
            allFacturas: [],
            calendarDate: '',
            dias: [],
            calendarPrices: {},
            items:[],
            itemsPrimerosMeses:[],
            diaDetail:[],
            mostrarTodos: false,
            tituloModal:'',
            sizeModal: 'sm',
            euro_libra: 0.84,
            libra_euro: 1.18,
            euro_dolar: 1.04,
            dolar_euro: 0.96, 
            empresaSeleccionada:{nombre:'Todas', id: 0, idCliente: 0},
            allPagos: [],
            diasFijados: [],
            nombreMesActual: "",
            nombreMesAnterior: "",            
            vistaMesActual: true,
            datosResumenMes: {
                gastoMedioDiaria: 0,
                gastoTotal: 0,
                gananciaMediaDiaria: 0,
                gananciaTotalDiaria: 0,
                gastoFacturas: 0,
                gananciaFacturas: 0,
                total: 0,
                cantidadDias: 0,
                gastosDevoluciones: 0,
                gananciaOrdenes: 0
            },
            categoriasCalculadas: [],
            totalCategorias: 0,
            mesSeleccionado: '',
            opcionesMes: [],
            anioSeleccionado: new Date().getFullYear(),
            primeraEjecucion: true,
            cargando: false,
            errores: "",
            mostrarCategoriasLista: true,
            seriesCategorias: [0, 0],
            chartCategorias: {
                chart: {
                type: "pie",
                height: 350,
                stacked: true,
                //stackType: "100%"
                },
                plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                        fontSize: "13px",
                        fontWeight: 900,
                        },
                    },
                    },
                },
                },
                dataLabels: {
                enabled: true,
                style: {
                    colors: ["#ffffff"],
                    fontWeight: "bold",
                },
                },
                legend: {
                show: true,
                },
                stroke: {
                width: 2,
                colors: ["#fff"],
                },
                title: {
                text: "Gastos categorias",
                align: "middle",
                },
                colors: this.coloresGrafica,
            },
            seriesDiaOrdenes: [{
                name: "Ventas",
                data: [0,0]
            }],
            chartDiaOrdenes: {
                chart: {
                type: "line",
                height: 400,
                stacked: true,
                //stackType: "100%"
                },
                plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                        fontSize: "13px",
                        fontWeight: 900,
                        },
                    },
                    },
                },
                },
                dataLabels: {
                enabled: true,
                style: {
                    colors: ["#ffffff"],
                    fontWeight: "bold",
                },
                },
                legend: {
                show: true,
                },
                stroke: {
                width: 2,
                colors: ["#fff"],
                },
                title: {
                text: "Ventas ordenes",
                align: "middle",
                },
                colors: this.coloresGrafica,
            },
            totalChartDiaOrdenes: 0,
            labelsChartDiaOrdenes: [],
            seriesDiaGastos: [{
                name: "Gastos",
                data: [0,0]
            }],
            chartDiaGastos: {
                chart: {
                type: "line",
                height: 400,
                stacked: true,
                //stackType: "100%"
                },
                plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                        fontSize: "13px",
                        fontWeight: 900,
                        },
                    },
                    },
                },
                },
                dataLabels: {
                enabled: true,
                style: {
                    colors: ["#ffffff"],
                    fontWeight: "bold",
                },
                },
                legend: {
                show: true,
                },
                stroke: {
                width: 2,
                colors: ["#fff"],
                },
                title: {
                text: "Gastos dia",
                align: "middle",
                },
                colors: this.coloresGrafica,
            },
            totalChartDiaGastos: 0,
            labelsChartDiaGastos: [],
            seriesDiaGastos: [{
                name: "Gastos",
                data: [0,0]
            },{
                name: "Ventas",
                data: [0,0]
            }],
            seriesDiaGastosVentas: [{
                name: "Gastos",
                data: [0,0]
            },{
                name: "Ventas",
                data: [0,0]
            }],
            chartDiaGastosVentas:
            {
                chart: {
                type: "line",
                height: 400,
                stacked: true,
                //stackType: "100%"
                },
                plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                        fontSize: "13px",
                        fontWeight: 900,
                        },
                    },
                    },
                },
                },
                dataLabels: {
                enabled: true,
                style: {
                    colors: ["#ffffff"],
                    fontWeight: "bold",
                },
                },
                legend: {
                show: true,
                },
                stroke: {
                width: 2,
                colors: ["#fff"],
                },
                title: {
                text: "Gastos dia",
                align: "middle",
                },
                colors: this.coloresGrafica,
            },
            diasPasadosGastos: [],
            diasPasadosVentas: [],
            mesesUltimos12: this.obtenerUltimos12Meses(),
        };
    },
    methods: {
        loadItemsSinShopify(){

            axios.post("/uso", {seccion:"kpi"});

            this.cargando = true;

            this.errores = "";

            Promise.all([
                axios.get("/shopify/exchange/GBP"),
                axios.get("/shopify/exchange/EUR")
            ]).then(responses => {
                const [gbpResponse, eurResponse] = responses;

                this.libra_euro = gbpResponse.data.rates.EUR;
                this.euro_libra = eurResponse.data.rates.GBP;

                this.calcular();

            }).catch(errors => {
                console.log(errors);
            });


            Promise.all([
                axios.get("/kpi/ingresos"),
                axios.get("/finanzas/gastos"),
                axios.get("/finanzas/facturas"),
                axios.get("/kpi/pagos"),
            ]).then(responses => {
                const [ingresosResponse, proveedoresResponse, facturasResponse, pagosResponse] = responses;

                //console.log(ingresosResponse.data);

                //Ingresos
                this.allIngresos = ingresosResponse.data;

                //Gastos
                this.allProveedores = proveedoresResponse.data;

                //Facturas
                this.allFacturas = facturasResponse.data;

                //Pagos
                this.allPagos = pagosResponse.data;

                const hoy = new Date();
                const anio = hoy.getFullYear();
                const mes = hoy.getMonth(); // Enero es 0

                let diaSemana = new Date(anio, mes, 1).getDay();
                if(diaSemana == 0)
                    diaSemana = 7;

                for(let i = 0; i < diaSemana-1; i++)
                {
                    this.dias.push({
                        Fecha: '',
                        total: 0,
                        empty: true
                    });
                }

                const daysInMonth = new Date(anio, mes + 1, 0).getDate();

                for (let dia = 2; dia <= daysInMonth+1; dia++) {
                    let fechaDia = new Date(anio, mes, dia).toISOString().split('T')[0];
                    let futuro = false;       
                                    
                    if(new Date(anio, mes, dia-1) >= new Date())
                    {
                        futuro = true;
                    }

                    this.dias.push({
                        Fecha: fechaDia,
                        total: 0,
                        empty: false,
                        futuro
                    });
                }

                this.primeraEjecucion = false;
                this.calcular();

                this.mesesUltimos12 = this.mesesUltimos12.map((data) => {

                    const mes = {value: data.value, data: [], dias: []};
                   
                    this.calcularMes(mes);
                    return {
                        ...data,
                        data: mes.data,
                        datosResumenMes: mes.datosResumenMes,
                        dias: mes.dias,
                        importe: mes.datosResumenMes?.total ?? '',
                        totalCategorias: mes.datosResumenMes?.totalCategorias ?? 0,
                        categoriasCalculadas: mes.categoriasCalculadas ?? [],
                    };
                    
                });

            }).catch(errors => {
                this.errores = errors.response?.data?.message || "Error al cargar los datos";
                console.log(errors);
            });

        },
        loadItems() {

            const arrayUltimos12 = this.mesesUltimos12.map(item => item.value);

            axios.post("/uso", {seccion:"kpi"});

            this.cargando = true;

            this.errores = "";

            const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
            const today = new Date();
            const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.nombreMesAnterior = monthNames[previousMonth.getMonth()];
            this.nombreMesActual = monthNames[today.getMonth()];

            Promise.all([axios.get("/kpi/orders")]).then(responses => {
                const [ordersResponse] = responses;
                this.items = ordersResponse.data;
                this.itemsPrimerosMeses = ordersResponse.data;

                 let sumaOrdenes = 0;

                this.items.forEach(element => {
                    sumaOrdenes += parseFloat(element.current_total_price);
                });

                this.ordenes = sumaOrdenes.toFixed(2)

                const orderNumbers = this.items.map((item) => item.name);

                Promise.all([
                    axios.get("/shopify/exchange/GBP"),
                    axios.get("/shopify/exchange/EUR")
                ]).then(responses => {
                    const [gbpResponse, eurResponse] = responses;

                    this.libra_euro = gbpResponse.data.rates.EUR;
                    this.euro_libra = eurResponse.data.rates.GBP;

                    this.calcular();

                }).catch(errors => {
                    console.log(errors);
                });


                Promise.all([
                    axios.post("/kpi/shipping/orders", {orderNumbers}),                    
                    axios.get("/finanzas/gastos"),
                    axios.get("/finanzas/facturas"),
                    axios.get("/kpi/pagos"),
                    axios.post("/kpi/orders/monthly/multiple", {values: arrayUltimos12})                    
                ]).then(responses => {
                    const [enviosResponse, proveedoresResponse, facturasResponse, pagosResponse, ordersMonthly] = responses;

                    //Ingresos
                    this.allIngresos = enviosResponse.data;

                    console.log(this.allIngresos);

                    //Envios
                    this.allEnvios = enviosResponse.data;

                    //Gastos
                    this.allProveedores = proveedoresResponse.data;

                    //Facturas
                    this.allFacturas = facturasResponse.data;

                    //Pagos
                    this.allPagos = pagosResponse.data;

                    const hoy = new Date();
                    const anio = hoy.getFullYear();
                    const mes = hoy.getMonth(); // Enero es 0

                    let diaSemana = new Date(anio, mes, 1).getDay();
                    if(diaSemana == 0)
                        diaSemana = 7;

                    for(let i = 0; i < diaSemana-1; i++)
                    {
                        this.dias.push({
                            Fecha: '',
                            total: 0,
                            empty: true
                        });
                    }

                    const daysInMonth = new Date(anio, mes + 1, 0).getDate();

                    for (let dia = 2; dia <= daysInMonth+1; dia++) {
                        let fechaDia = new Date(anio, mes, dia).toISOString().split('T')[0];
                        let futuro = false;       
                                     
                        if(new Date(anio, mes, dia-1) >= new Date())
                        {
                            futuro = true;
                        }

                        this.dias.push({
                            Fecha: fechaDia,
                            total: 0,
                            empty: false,
                            futuro
                        });
                    }

                    this.primeraEjecucion = false;
                    this.calcular();

                    this.mesesUltimos12 = this.mesesUltimos12.map((data) => {
                        const mes = Array.isArray(ordersMonthly?.data)
                            ? ordersMonthly.data.find(m => m.value === data.value)
                            : undefined;

                        const [anioStr, mesStr] = data.value.split("-");
                        const mesIndex = parseInt(mesStr, 10) - 1;
                        const nombreMes = monthNames[mesIndex];

                        if (mes) {
                            this.calcularMes(mes);
                            return {
                                ...data,
                                data: mes.data,
                                datosResumenMes: mes.datosResumenMes,
                                dias: mes.dias,
                                importe: mes.datosResumenMes?.total ?? '',
                                totalCategorias: mes.datosResumenMes?.totalCategorias ?? 0,
                                categoriasCalculadas: mes.categoriasCalculadas ?? [],
                            };
                        } else if (nombreMes === this.nombreMesActual || nombreMes === this.nombreMesAnterior) {                            
                            // 👉 Mes actual o anterior: usar itemsPrimerosMeses
                            const mesTemp = {
                                value: data.value,
                                data: this.itemsPrimerosMeses,
                                dias: [], 
                            };
                            this.calcularMes(mesTemp);
                            return {
                                ...data,
                                data: this.itemsPrimerosMeses,
                                dias: mesTemp.dias,
                                datosResumenMes: mesTemp.datosResumenMes,
                                importe: mesTemp.datosResumenMes?.total ?? '',
                                totalCategorias: mesTemp.datosResumenMes?.totalCategorias ?? 0,
                                categoriasCalculadas: mesTemp.categoriasCalculadas ?? [],
                            };
                        } else {
                            return {
                                ...data,
                                data: [],
                                dias: [],
                                datosResumenMes: {},
                                importe: '',
                            };
                        }
                    });

                    let dataImp = [];
                    let dataImpDias = [];

                    let totalPrueba = 0;

                    //Pruebas

                    this.mesesUltimos12[2].data.forEach(data => {
                        const cleanPrice = data.current_total_price
                            .toString()
                            .replace(/[^\d.-]/g, ''); // elimina todo lo que no sea número, punto o guion

                        const parsed = parseFloat(cleanPrice);
                        totalPrueba += parsed;
                        dataImp.push({
                            created_at: data.created_at,
                            current_total_price: data.current_total_price,
                            name: data.name
                        });
                    });

                    this.mesesUltimos12[0].dias.forEach(dia => {
                        //dataImpDias.push(dia.ord)
                        if(!dia.empty) {
                            dia.ordenes.items.forEach(item => {
                                dataImpDias.push({
                                    created_at: item.created_at,
                                    current_total_price: item.current_total_price,
                                    name: item.name
                                });
                            });
                        }
                    });

                    //totalPrueba = 0;
                    //let 

                    //console.log(this.mesesUltimos12);

                    let diaSeleccionado = 7;
                        
                    this.mesesUltimos12[2].dias[diaSeleccionado].ordenes.items.forEach(data => {
                        const cleanPrice = data.current_total_price
                            .toString()
                            .replace(/[^\d.-]/g, ''); // elimina todo lo que no sea número, punto o guion

                            //console.log(data.name, cleanPrice);

                        const parsed = parseFloat(cleanPrice);
                        //totalPrueba += parsed;
                    });
                        
            

                    //totalPrueba = totalPrueba * this.libra_euro;
                    //console.log("Total Prueba:", totalPrueba*this.libra_euro);

                    //console.log(this.mesesUltimos12[2].dias[diaSeleccionado].ordenes.total);

                    /*console.log(dataImp);
                    console.log(dataImpDias);*/
                        

                    
                    //Pruebas

                }).catch(errors => {
                    this.errores = errors.response?.data?.message || "Error al cargar los datos";
                    console.log(errors);
                });

                //console.log(responses);
            }).catch(errors => {
                this.errores = errors.response?.data?.message || "Error al cargar los datos";
                console.log(errors);
            });

            //Envios

        },
        toggleDesglosar(index) {
            this.$set(this.dias, index, {
                ...this.dias[index],
                desglosar: !this.dias[index].desglosar
            });
        },
        toggleFijar(index) {
            this.$set(this.dias, index, {
                ...this.dias[index],
                fijado: !this.dias[index].fijado
            });

            if (this.dias[index].fijado) {
                this.diasFijados.push(this.dias[index]);
            } else {
                const idxToRemove = this.diasFijados.findIndex(item => item.id === this.dias[index].id);
                if (idxToRemove !== -1) {
                    this.diasFijados.splice(idxToRemove, 1);
                }
            }
        },
        desfijarTodos(){
            this.diasFijados = [];

            this.dias.forEach(element => {
                element.fijado = false;
            });
        },
        toggleDesglosarTodos(valor) {
            this.mostrarTodos = valor;
            this.dias.forEach((dia, index) => {
                this.$set(this.dias, index, {
                    ...dia,
                    desglosar: valor
                });
            });

        },
        cargarDatosMes() {
            if (!this.mesSeleccionado?.value) return;

            const mesExistente = this.mesesUltimos12.find(m => m.value === this.mesSeleccionado.value);
            if (mesExistente && mesExistente.dias?.length > 0) {
                this.dias = mesExistente.dias;                
                this.calcularResumen();
                return;
            }            
        },

        cargarDatosMes2() {
            if (!this.mesSeleccionado?.value) return;

            this.cargando = true;

            const [yearStr, monthStr] = this.mesSeleccionado.value.split('-');
            const year = parseInt(yearStr);
            const month = parseInt(monthStr);


            const now = new Date();
            const mesActual = now.getMonth() + 1;
            const anioActual = now.getFullYear();

            const esMesActual = month === mesActual && year === anioActual;
            const esMesAnterior = 
                (month === mesActual - 1 && year === anioActual) ||
                (mesActual === 1 && month === 12 && year === anioActual - 1);

            const endpoint = (esMesActual || esMesAnterior)
                ? '/kpi/orders'
                : '/kpi/orders/monthly';

            const cargarItems = () => {
                if (esMesActual || esMesAnterior) {
                    return Promise.resolve(this.itemsPrimerosMeses);
                } else {
                    return axios.get(endpoint, { params: { month, year } }).then(res => res.data);
                }
            };

            const calcularOrdenes = (items) => {
                let suma = 0;
                items.forEach(el => suma += parseFloat(el.current_total_price));
                this.ordenes = suma.toFixed(2);
                return items.map(item => item.name);
            };

            const generarDias = () => {
                this.dias = [];

                const primerDia = new Date(year, month - 1, 1);
                let diaSemana = primerDia.getDay() || 7;

                // Días vacíos al inicio
                for (let i = 0; i < diaSemana - 1; i++) {
                    this.dias.push({ Fecha: '', total: 0, empty: true });
                }

                const diasMes = new Date(year, month, 0).getDate();
                for (let dia = 2; dia <= diasMes + 1; dia++) {
                    const fecha = new Date(year, month - 1, dia);
                    const fechaISO = fecha.toISOString().split('T')[0];
                    const futuro = fecha >= now;
                    this.dias.push({ Fecha: fechaISO, total: 0, empty: false, futuro });
                }
            };

            cargarItems()
                .then(items => {
                    this.items = items;
                    const orderNumbers = calcularOrdenes(items);

                    return axios.post("/kpi/shipping/orders", { orderNumbers });
                })
                .then(response => {
                    this.allEnvios = response.data;
                    generarDias();
                    this.calcular();
                })
                .catch(err => {
                    console.error("Error al cargar datos del mes:", err);
                });
        },
        cambiarVistaMes(valor)
        {
            this.vistaMesActual = valor;

            this.dias = [];

            if(this.vistaMesActual)
            {
                const hoy = new Date();
                const anio = hoy.getFullYear();
                const mes = hoy.getMonth(); // Enero es 0

                let diaSemana = new Date(anio, mes, 1).getDay();
                if(diaSemana == 0)
                    diaSemana = 7;

                for(let i = 0; i < diaSemana-1; i++)
                {
                    this.dias.push({
                        Fecha: '',
                        total: 0,
                        empty: true
                    });
                }

                const daysInMonth = new Date(anio, mes + 1, 0).getDate();

                for (let dia = 2; dia <= daysInMonth+1; dia++) {
                    let fechaDia = new Date(anio, mes, dia).toISOString().split('T')[0];
                    let futuro = false;       
                                    
                    if(new Date(anio, mes, dia-1) >= new Date())
                    {
                        futuro = true;
                    }

                    this.dias.push({
                        Fecha: new Date(anio, mes, dia).toISOString().split('T')[0],
                        total: 0,
                        empty: false,
                        futuro
                    });
                }

                this.calcular();
            }
            else{
                const hoy = new Date();
                //const anio = hoy.getFullYear();
                let mes = hoy.getMonth() - 1; // Mes anterior
                let anio = hoy.getFullYear();
                if (mes < 0) {
                    mes = 11; // Diciembre
                    anio -= 1; // Año anterior
                }

                let diaSemana = new Date(anio, mes, 1).getDay();
                if(diaSemana == 0)
                    diaSemana = 7;

                for(let i = 0; i < diaSemana-1; i++)
                {
                    this.dias.push({
                        Fecha: '',
                        total: 0,
                        empty: true
                    });
                }

                const daysInMonth = new Date(anio, mes + 1, 0).getDate();

                for (let dia = 2; dia <= daysInMonth+1; dia++) {
                    this.dias.push({
                        Fecha: new Date(anio, mes, dia).toISOString().split('T')[0],
                        total: 0,
                        empty: false
                    });
                }

                this.calcular();
            }
        },
        mostrarFacturas(item,fecha){
            if(item.total == 0)
                return;
            this.sizeModal = 'xl';
            this.tituloModal = `Facturas del ${fecha}`;
            this.diaDetail = item.items;

            this.columnasDetails = [
                {
                    key: "codigo",
                    label: "Codigo",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "categoria",
                    label: "Categoria",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "cliente",
                    label: "Cliente",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "notas",
                    label: "Notas",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "total",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarProveedores(item, fecha){
            if(item.total == 0)
                return;
            this.sizeModal = 'sm';
            this.tituloModal = `Proveedores del ${fecha}`;
            this.diaDetail = item.items;

            this.columnasDetails = [
                {
                    key: "codigo",
                    label: "Factura",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "proveedor",
                    label: "Empresa",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "total",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarEnvios(item, fecha){
            if(item.total == 0)
                return;
            this.sizeModal = 'lg';
            this.tituloModal = `Envios del ${fecha}`;
            this.diaDetail = item.items;

            
            this.columnasDetails = [
                {
                    key: "nombre",
                    label: "Nombre",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "descripcion",
                    label: "Descripcion",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "categoria",
                    label: "Categoria",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "precio",
                    label: "Precio",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarOrdenes(item, fecha){
            if(item.total == 0)
                return;
            this.sizeModal = 'lg';
            this.tituloModal = `Ordenes del ${fecha}`;
            this.diaDetail = item.items;

            this.diaDetail.forEach(element => {
                element.sku = "";
                element.line_items.forEach(item => {
                    if(item.sku != "GIFT-PACKAGING" && item.sku != "GIFT-CARD" && item.sku != "DEBOSS-CUSTOMIZATION")
                        element.sku += item.sku + " ";
                });
                
            });

            this.columnasDetails = [
                {
                    key: "name",
                    label: "Orden",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
                {
                    key: "sku",
                    label: "Sku",
                    sortable: true,
                    thStyle: { width: "80%" },
                },
                {
                    key: "current_total_price",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarIngresos(item, fecha){
            if(item.total == 0)
                return;
            this.sizeModal = 'lg';
            this.tituloModal = `Ingresos del ${fecha}`;
            this.diaDetail = item.items;

            this.columnasDetails = [
                {
                    key: "banco",
                    label: "Banco",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "nombre",
                    label: "Nombre",
                    sortable: true,
                    thStyle: { width: "20%" },
                },            
                {
                    key: "total",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarDevoluciones(item, fecha){
            if(item.total == 0)
                return;
            this.sizeModal = 'sm';
            this.tituloModal = `Devoluciones del ${fecha}`;
            this.diaDetail = item.items;

            this.diaDetail.forEach(element => {
                element.sku = "";
                element.line_items.forEach(item => {
                    if(item.sku != "GIFT-PACKAGING" && item.sku != "GIFT-CARD" && item.sku != "DEBOSS-CUSTOMIZATION")
                        element.sku += item.sku + " ";
                });
                
            });

            item.items.forEach(order => {
                let totalRefund = 0;
                order.refunds.forEach(refund => {
                let amount = 0;

                refund.transactions.forEach(lineRefund => {

                    if (lineRefund.currency != 'gbp')
                    {
                        if (lineRefund.receipt.balance_transaction != undefined && lineRefund.receipt.balance_transaction.exchange_rate != null)
                            amount = parseFloat(lineRefund.amount) * lineRefund.receipt.balance_transaction.exchange_rate;
                    }
                    else
                        amount = parseFloat(lineRefund.amount);

                    if(amount > 0){
                        totalRefund += amount;
                    }
                        
                    });
                });

                order.totalRefund = totalRefund.toFixed(2);
            });

            this.columnasDetails = [
                {
                    key: "name",
                    label: "Orden",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
                {
                    key: "totalRefund",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarPagos(item,fecha,titulo="Puntuales"){
            if(item.total == 0)
                return;
            this.sizeModal = 'lg';
            this.tituloModal = `Pagos ${titulo} del ${fecha}`;
            this.diaDetail = item.items;

            this.columnasDetails = [
                {
                    key: "nombre",
                    label: "Nombre",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "descripcion",
                    label: "Descripcion",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "categoria",
                    label: "Categoria",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "precio",
                    label: "Precio",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },
        mostrarPagosCategoria(item,titulo){
            titulo = item.categoria;

            if(item.total == 0)
                return;
            this.sizeModal = 'sm';
            this.tituloModal = `Pagos de ${titulo}`;
            this.diaDetail = item.items;

            this.columnasDetails = [
                {
                    key: "nombre",
                    label: "Nombre",
                    sortable: true,
                    thStyle: { width: "20%" },
                },   
                {
                    key: "total",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "5%" },
                },
            ],

            this.$bvModal.show('modal-detail');
        },     
        calcularMes(dataMes){

            function resetTime(date) {
                return new Date(date.getFullYear(), date.getMonth(), date.getDate());
            }

            function calcularTotal({
                    ingresos,
                    facturasPositivas,
                    envios,
                    proveedores,
                    facturasNegativas,
                    pagosPuntualesDia,
                    pagosMensuales,
                    pagosAnuales,
                    euro_libra
                    }) {
                    let total = 0;

                    //console.log('--- Inicio cálculo total ---');
                    
                    // Ordenes: ya está en libras, no convertir
                    //console.log(`Ordenes (libras, sin conversión): ${ordenes.total.toFixed(2)}`);
                    total += ingresos.total;
                    //console.log(`Total después Ordenes: ${total.toFixed(2)}`);

                    // Función para convertir y mostrar
                    function convertirYSumar(nombre, valorEuros) {
                        const valorLibras = valorEuros * euro_libra;
                        //console.log(`${nombre} (euros): ${valorEuros.toFixed(2)} => (libras): ${valorLibras.toFixed(2)}`);
                        total += valorLibras;
                        //console.log(`Total después ${nombre}: ${total.toFixed(2)}`);
                    }

                    convertirYSumar('Facturas Positivas', facturasPositivas.total);
                    convertirYSumar('Envios', envios.total);
                    convertirYSumar('Proveedores', proveedores.total);
                    convertirYSumar('Facturas Negativas', facturasNegativas.total);
                    convertirYSumar('Pagos Puntuales', pagosPuntualesDia.total);
                    convertirYSumar('Pagos Mensuales', pagosMensuales.total);
                    convertirYSumar('Pagos Anuales', pagosAnuales.total);

                    //console.log('--- Cálculo total finalizado ---');
                    //console.log(`TOTAL FINAL: £${total.toFixed(2)}`);

                    return total;
                    }


            function normalizarFecha(fechaStr) {
                if (!fechaStr) return null;

                // Intentamos crear un objeto Date directamente
                let fecha = new Date(fechaStr);
                if (!isNaN(fecha)) return fecha.setHours(0, 0, 0, 0);

                // Si no es válida, probamos con formato DD-MM-YYYY
                const regexDMY = /^(\d{2})[-/](\d{2})[-/](\d{4})$/;
                const match = fechaStr.match(regexDMY);
                
                if (match) {
                    const [_, dia, mes, año] = match.map(Number);
                    return new Date(año, mes - 1, dia).setHours(0, 0, 0, 0);
                }

                return null; // No se pudo interpretar la fecha
            }


            function generarDias(year, month){
                const dias = [];

                const primerDia = new Date(year, month - 1, 1);
                let diaSemana = primerDia.getDay() || 7;

                // Días vacíos al inicio
                for (let i = 0; i < diaSemana - 1; i++) {
                    dias.push({ Fecha: '', total: 0, empty: true });
                }

                const diasMes = new Date(year, month, 0).getDate();
                const ahora = new Date();
                for (let dia = 2; dia <= diasMes + 1; dia++) {
                    const fecha = new Date(year, month - 1, dia);
                    const fechaISO = fecha.toISOString().split('T')[0];
                    const futuro = new Date(year, month - 1, dia - 1) >= ahora;
                    dias.push({ Fecha: fechaISO, total: 0, empty: false, futuro });
                }

                return dias;
            };

            dataMes.dias = generarDias(parseInt(dataMes.value.split('-')[0]), parseInt(dataMes.value.split('-')[1]));


            let ordenes_total_price = 0;
            let ordenes_current_total_price = 0;

            dataMes.dias.forEach(element => {
                if(element.empty)
                    return;
                element.total = 0;
                element.totalEur = 0;

                const fecha = new Date(element.Fecha);
                const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
                element.diaSemana = diasSemana[fecha.getDay()];
                element.diaNumero = fecha.getDate();

                const fechaSinHoras = new Date(element.Fecha).setHours(0, 0, 0, 0);

                element.desglosar = this.mostrarTodos;
                element.fijado = false;

                /*
                //Ordenes
                let ordenes = {total: 0, items:[]};
                dataMes.data.find(item => {                    
                    if (item.created_at != null && item.created_at.split('T')[0] == element.Fecha && (this.empresaSeleccionada.nombre == 'Harber London' || this.empresaSeleccionada.nombre == 'Todas')) {
                        ordenes.total += parseFloat(item.current_total_price);

                        let curTotalPrice = parseFloat(item.current_total_price);
                        let TotalPrice = parseFloat(item.total_price);


                        ordenes.items.push(item);

                        ordenes_total_price += parseFloat(item.total_price);
                        ordenes_current_total_price += parseFloat(item.current_total_price);

                    }
                });

                //Refunds
                let ordenesRefund = {total: 0, items:[]};
                dataMes.data.find(item => {
                    let totalRefund = 0
                    let refundValido = false;

                    item.refunds.forEach(refund => {

                        if(refund.created_at.split('T')[0] == element.Fecha && (this.empresaSeleccionada.nombre == 'Harber London' || this.empresaSeleccionada.nombre == 'Todas')) {
                            if(refund.transactions.length > 0){
                                refund.transactions.forEach(lineRefund => {

                                    let amount = 0;

                                    if (lineRefund.currency != 'gbp' && lineRefund.currency != 'GBP')
                                    {
                                        if (lineRefund.receipt.balance_transaction != undefined && lineRefund.receipt.balance_transaction.exchange_rate != null)
                                            amount = parseFloat(lineRefund.amount) * lineRefund.receipt.balance_transaction.exchange_rate;
                                    }
                                    else
                                        amount = parseFloat(lineRefund.amount);
                                    
                                    if(amount > 0){
                                        ordenesRefund.total -= amount;
                                        refundValido = true;
                                        totalRefund += amount;
                                    }
                                        
                                });
                                
                            }
                        }
                    });

                    item.totalRefund = totalRefund;

                    if(refundValido)
                    {
                        ordenesRefund.items.push(item);
                    }
                    
                });
                */
                //Ingresos
                let ingresos = {total: 0, items:[]};
                this.allIngresos.find(item => {
                    if (item.fecha == element.Fecha && (this.empresaSeleccionada.nombre == 'Harber London' || this.empresaSeleccionada.nombre == 'Todas')) {
                        ingresos.total += parseFloat(item.total);
                        ingresos.items.push(item);
                    }
                });

                //Proveedores
                let proveedores = {total: 0, items:[]};
                this.allProveedores.find(item => {
                    if (item.fechaPagado == element.Fecha && (item.nombreEmpresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas')) {
                        proveedores.total -= parseFloat(item.total);
                        proveedores.items.push(item);
                    }
                });
            
                //Facturas Negativas
                let facturasNegativas = {total: 0, items:[]};
                this.allFacturas.find(item => {
                    const esMismaFecha = item.fechaPagado == element.Fecha;
                    const esMismoCliente = item.idCliente == this.empresaSeleccionada.idCliente;
                    const esEmpresaSeleccionadaTodas = this.empresaSeleccionada.nombre == 'Todas';
                    const esClientePermitido = item.cliente == "Craft Lab SL" || item.cliente == "Harber London Ltd";

                    if (esMismaFecha && (esMismoCliente || (esEmpresaSeleccionadaTodas && esClientePermitido))) {
                            facturasNegativas.total -= parseFloat(item.total);
                            facturasNegativas.items.push(item);
                    }
                });

                //Facturas Positivas
                let facturasPositivas = {total: 0, items:[]};
                this.allFacturas.find(item => {
                    const esMismaFecha = item.fechaPagado == element.Fecha;
                    const esEmpresaSeleccionadaTodas = this.empresaSeleccionada.nombre == 'Todas';
                    const esMismaEmpresa = item.idEmpresa == this.empresaSeleccionada.id;

                    if (esMismaFecha && (esEmpresaSeleccionadaTodas || esMismaEmpresa)) {
                        facturasPositivas.total += parseFloat(item.total);
                        facturasPositivas.items.push(item);
                    }
                });

                //Pagos puntuales
                let pagosPuntualesDia = {total: 0, totalEuro: 0, totalLibra: 0, totalDolar:0, items:[]};
                this.allPagos.find(item => {
                  
                    let fechaInicioPago = normalizarFecha(item.fecha);

                    if (fechaInicioPago == fechaSinHoras && item.tipoGasto == 'puntual' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas')) {
                        if(item.moneda == 'Euro')
                            pagosPuntualesDia.totalEuro -= parseFloat(item.precio);
                        else if(item.moneda == 'Libra')
                            pagosPuntualesDia.totalLibra -= parseFloat(item.precio);
                        else
                            pagosPuntualesDia.totalDolar -= parseFloat(item.precio);

                            pagosPuntualesDia.items.push(item);
                    }
                });

                 //Envios
                 let envios = {total: 0, items:[]};
                 this.allPagos.find(item => {
                  
                    let fechaInicioPago = normalizarFecha(item.fecha);

                    if (fechaInicioPago == fechaSinHoras && item.tipoGasto == 'envios' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas')) {
                        envios.total -= parseFloat(item.precio);
                        envios.items.push(item);
                    }
                });


                pagosPuntualesDia.total += pagosPuntualesDia.totalEuro;
                pagosPuntualesDia.total += pagosPuntualesDia.totalLibra * this.libra_euro;
                pagosPuntualesDia.total += pagosPuntualesDia.totalDolar * this.dolar_euro;

                function getDaysInMonth(date) {
                    const year = date.getFullYear();
                    const month = date.getMonth() + 1; // getMonth() es base 0, sumamos 1
                    return new Date(year, month, 0).getDate(); // Día 0 del mes siguiente es el último del actual
                }

                let fechaReset = resetTime(fecha);

                //Pagos mensuales
                let pagosMensuales = {total: 0, totalEuro: 0, totalLibra: 0, totalDolar:0, items:[]};
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'mensual')
                    {
                        let fechaInicioPago = new Date(item.fechaInicio);
                        fechaInicioPago = resetTime(fechaInicioPago);
                        if(fechaReset >= fechaInicioPago)
                        {
                            let continuar = false;
                            if(item.fechaFin == "")
                                continuar = true
                            else{
                                let fechaFinPago = new Date(item.fechaFin);
                                fechaFinPago = resetTime(fechaFinPago);
                                if(fechaReset <= fechaFinPago)
                                    continuar = true;   
                            }

                            if(continuar)
                            {
                                if(item.tipoGasto == 'mensual' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                                {
                                    let precioDia = item.precio / getDaysInMonth(fecha);
                                    if(item.moneda == 'Euro')
                                        pagosMensuales.totalEuro -= parseFloat(precioDia);
                                    else if(item.moneda == 'Libra')
                                        pagosMensuales.totalLibra -= parseFloat(precioDia);
                                    else
                                        pagosMensuales.totalDolar -= parseFloat(precioDia);

                                    pagosMensuales.items.push(item);
                                }
                            }
                            
                        } 
                    }
                });

                //ADS - se suma al pago mensual
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'ads')
                    {
                        let fechaInicioPago = new Date(item.fecha);
                        fechaInicioPago = resetTime(fechaInicioPago);
                        fechaInicioPago.setDate(1);
                        
                        if(fechaReset >= fechaInicioPago)
                        {
                            let fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 1, 0);
                            fechaFinPago = resetTime(fechaFinPago);
                            
                            if(fechaReset <= fechaFinPago)
                            {                              
                                if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                                {
                                    let precioDia = item.precio / getDaysInMonth(fecha);
                                    if(item.moneda == 'Euro')
                                        pagosMensuales.totalEuro -= parseFloat(precioDia);
                                    else if(item.moneda == 'Libra')
                                        pagosMensuales.totalLibra -= parseFloat(precioDia);
                                    else
                                        pagosMensuales.totalDolar -= parseFloat(precioDia);

                                    pagosMensuales.items.push(item);
                                }
                            }

                        }
                        else{
                        }
                    }
                });

                function parseDMY(fechaStr) {
                    const [dia, mes, año] = fechaStr.split("-");
                    return new Date(`${año}-${mes}-${dia}`); // formato ISO: YYYY-MM-DD
                }

                //Nomina - se suma al pago mensual
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'nomina')
                    {

                        let fechaInicioPago = new Date(item.fecha); // item.fecha = "31-03-2025"
                        fechaInicioPago = resetTime(fechaInicioPago);
                        fechaInicioPago.setDate(1);
                        fechaInicioPago.setMonth(fechaInicioPago.getMonth() + 1);

                        if(fechaReset >= fechaInicioPago)
                        {

                            let fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 1, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            if(fechaReset <= fechaFinPago)
                            {

                                
                                if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                                {
                                    let precioDia = item.precio / getDaysInMonth(fecha);
                                    if(item.moneda == 'Euro')
                                        pagosMensuales.totalEuro -= parseFloat(precioDia);
                                    else if(item.moneda == 'Libra')
                                        pagosMensuales.totalLibra -= parseFloat(precioDia);
                                    else
                                        pagosMensuales.totalDolar -= parseFloat(precioDia);

                                    pagosMensuales.items.push(item);
                                }
                            }

                        }
                    }
                });

                //Impuestos mensuales - se suma al pago mensual
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'impuestos')
                    {
                        let fechaInicioPago;
                        let fechaFinPago;
                        let precioDia;

                        if(item.tipoCobroAnual == 'mensual' || item.tipoCobroAnual=='' ){
                            fechaInicioPago = new Date(item.fecha);
                            fechaInicioPago = resetTime(fechaInicioPago);
                            fechaInicioPago.setDate(1);

                            fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 1, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            precioDia = item.precio / getDaysInMonth(fecha);
                        }
                        else if(item.tipoCobroAnual == 'trimestral'){
                            fechaInicioPago = new Date(item.fecha);
                            fechaInicioPago = resetTime(fechaInicioPago);
                            //fechaInicioPago.setMonth(fechaInicioPago.getMonth() + 1);
                            fechaInicioPago.setDate(1);

                            fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 2, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            precioDia = item.precio / 90;
                        }
                        else if(item.tipoCobroAnual == 'semestral' ){
                            fechaInicioPago = new Date(item.fecha);
                            fechaInicioPago = resetTime(fechaInicioPago);
                            //fechaInicioPago.setMonth(fechaInicioPago.getMonth() + 1);
                            fechaInicioPago.setDate(1);

                            fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 5, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            precioDia = item.precio / 180;
                        }

                        if(fechaReset >= fechaInicioPago && fechaReset <= fechaFinPago)
                        {              
                            if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                            {
                                
                                if(item.moneda == 'Euro')
                                    pagosMensuales.totalEuro -= parseFloat(precioDia);
                                else if(item.moneda == 'Libra')
                                    pagosMensuales.totalLibra -= parseFloat(precioDia);
                                else
                                    pagosMensuales.totalDolar -= parseFloat(precioDia);

                                item.precioDia = precioDia;
                                pagosMensuales.items.push(item);
                            }
                        }
                    }
                });


                pagosMensuales.total += pagosMensuales.totalEuro;
                pagosMensuales.total += (pagosMensuales.totalLibra * this.libra_euro);
                pagosMensuales.total += (pagosMensuales.totalDolar * this.dolar_euro);

                //Pagos anuales
                let pagosAnuales = {total: 0, totalEuro: 0, totalLibra: 0, totalDolar:0, items:[]};
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'anual')
                    {
                        let continuarFecha = false;

                        let fechaInicioPago = "";
                        let fechaFinPago = "";

                        let fechaAnual = new Date(item.fecha);
                        if(item.tipoCobroAnual == 'natural'){
                            fechaInicioPago = new Date(fechaAnual.getFullYear(),1, 1);
                            fechaFinPago = new Date(fechaAnual.getFullYear(),12, 31);

                            if(fecha >= fechaInicioPago && fecha <= fechaFinPago)
                                continuarFecha = true;
                        }
                        else if(item.tipoCobroAnual == 'retrospectivo anterior'){
                            fechaInicioPago = new Date(fechaAnual);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() - 1);

                            if(fecha <= fechaInicioPago && fecha >= fechaFinPago)
                                continuarFecha = true;                          
                        }
                        else if(item.tipoCobroAnual == 'retrospectivo siguiente'){
                            fechaInicioPago = new Date(fechaAnual);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() + 1);

                            if(fecha >= fechaInicioPago && fecha <= fechaFinPago)
                                continuarFecha = true;
                        }

                        if(continuarFecha)
                        {
                            if(item.tipoGasto == 'anual' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                            {
                                let precioDia = item.precio / 365;
                                if(item.moneda == 'Euro')
                                    pagosAnuales.totalEuro -= parseFloat(precioDia);
                                else if(item.moneda == 'Libra')
                                    pagosAnuales.totalLibra -= parseFloat(precioDia);
                                else
                                    pagosAnuales.totalDolar -= parseFloat(precioDia);

                                pagosAnuales.items.push(item);
                            }
                        }
                    }
                });

                 //Impuestos anuales - se suma al pago anual
                 this.allPagos.find(item => {
                    if(item.tipoGasto == 'impuestos')
                    {
                        let fechaInicioPago;
                        let fechaFinPago;

                       if(item.tipoCobroAnual == 'retrospectivo anterior'){

                            fechaInicioPago = new Date(item.fecha);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() - 1);
                        }
                        else if(item.tipoCobroAnual == 'retrospectivo siguiente'){
                            fechaInicioPago = new Date(item.fecha);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() + 1);
                        }

                        if(fechaReset >= fechaInicioPago && fechaReset <= fechaFinPago)
                        {
                            if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                            {
                                let precioDia = item.precio / 365;
                                if(item.moneda == 'Euro')
                                    pagosAnuales.totalEuro -= parseFloat(precioDia);
                                else if(item.moneda == 'Libra')
                                    pagosAnuales.totalLibra -= parseFloat(precioDia);
                                else
                                    pagosAnuales.totalDolar -= parseFloat(precioDia);

                                pagosAnuales.items.push(item);
                            }
                        }
                    }
                });

                pagosAnuales.total += pagosAnuales.totalEuro;
                pagosAnuales.total += pagosAnuales.totalLibra * this.libra_euro;
                pagosAnuales.total += pagosAnuales.totalDolar * this.dolar_euro;               

                //Sumas                

                element.total = 0;

                const resultado = calcularTotal({
                    ingresos: { total: ingresos.total },
                    facturasPositivas: { total: facturasPositivas.total },
                    envios: { total: envios.total },
                    proveedores: { total: proveedores.total },
                    facturasNegativas: { total: facturasNegativas.total },
                    pagosPuntualesDia: { total: pagosPuntualesDia.total },
                    pagosMensuales: { total: pagosMensuales.total },
                    pagosAnuales: { total: pagosAnuales.total },
                    euro_libra: this.euro_libra
                    });

                    element.total = resultado;
                

                element.totalEur = element.total * this.libra_euro;

                //Redondear
                ingresos.total = ingresos.total.toFixed(2);
                envios.total = envios.total.toFixed(2);
                proveedores.total = proveedores.total.toFixed(2);
                facturasNegativas.total = facturasNegativas.total.toFixed(2);
                facturasPositivas.total = facturasPositivas.total.toFixed(2);
                element.total = element.total.toFixed(2);
                element.totalEur = element.totalEur.toFixed(2);
                pagosPuntualesDia.total = pagosPuntualesDia.total.toFixed(2);
                pagosMensuales.total = pagosMensuales.total.toFixed(2);
                pagosAnuales.total = pagosAnuales.total.toFixed(2);

                element.ingresos = ingresos;
                element.envios = envios;
                element.proveedores = proveedores;
                element.facturasNegativas = facturasNegativas;
                element.facturasPositivas = facturasPositivas;
                element.pagosPuntualesDia = pagosPuntualesDia;
                element.pagosMensuales = pagosMensuales;
                element.pagosAnuales = pagosAnuales;

            });

            

            this.calcularResumenMes(dataMes);

            //console.log(this.dias);
        },  
        calcularResumenMes(dataMes){
            dataMes.totalCategorias = 0;
            dataMes.categoriasCalculadas = [];

            dataMes.datosResumenMes= {
                gastoMedioDiaria: 0,
                gastoTotal: 0,
                gananciaMediaDiaria: 0,
                gananciaTotalDiaria: 0,
                gastoFacturas: 0,
                gananciaFacturas: 0,
                total: 0,
                cantidadDias: 0,
                gastosDevoluciones: 0,
                gananciaOrdenes: 0
            };

            const getDaysInMonth = (date) => {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                return new Date(year, month, 0).getDate();
            };

            const calcularPrecio = (pago) => {
                let tasaCambio = 1;
                const moneda = pago.moneda?.toLowerCase().trim() || 'euro';
                if (moneda === 'libra') tasaCambio = this.libra_euro;
                else if (moneda !== 'euro'){ tasaCambio = this.dolar_euro};

                return (parseFloat(pago.precio) * tasaCambio);
            };

            const calcularPrecioDia = (pago) => {
                let tasaCambio = 1;
                const moneda = pago.moneda?.toLowerCase().trim() || 'euro';
                if (moneda === 'libra') tasaCambio = this.libra_euro;
                else if (moneda !== 'euro'){ tasaCambio = this.dolar_euro};
                
                return (parseFloat(pago.precioDia) * tasaCambio);
            };

            const procesarPagos = (pagos,dataMes, divisor = 1) => {
                let total = 0;
                if (!pagos?.items) return;

                pagos.items.forEach(pago => {
                    let precioPago = 0;
                    if(pago.precioDia != undefined)
                        precioPago = calcularPrecioDia(pago);
                    else
                        precioPago = calcularPrecio(pago) / divisor;
                    let categoriaExistente = dataMes.categoriasCalculadas.find(cat => cat.categoria === pago.categoria);

                    total+= precioPago;

                    if (!categoriaExistente) {
                        dataMes.categoriasCalculadas.push({
                            categoria: pago.categoria,
                            precio: precioPago,
                            items: [{ nombre: pago.nombre, total: precioPago, pagos: [pago] }]
                        });
                    } else {
                        let itemExistente = categoriaExistente.items.find(item => item.nombre === pago.nombre);
                        if (itemExistente) {
                            itemExistente.total += precioPago;
                            itemExistente.pagos.push(pago);
                        } else {
                            categoriaExistente.items.push({
                                nombre: pago.nombre,
                                total: precioPago,
                                pagos: [pago]
                            });
                        }
                        categoriaExistente.precio += precioPago;
                    }
                });

                return total;

            };

            let gastoTotal = 0;
            let refundTotal = 0;

            dataMes.dias.forEach(dia => {
                if (!dia.empty) {
                    const pagosProveedores = {
                        items: (dia.proveedores?.items || []).map(p => ({
                            categoria: "Proveedores",
                            nombre: p.proveedor,
                            precio: p.total,
                            moneda: "Euro"
                        }))
                    };

                    const fecha = new Date(dia.Fecha);

                    gastoTotal += parseFloat(dia.envios.total);
                    gastoTotal += parseFloat(dia.pagosAnuales.total);
                    gastoTotal += parseFloat(dia.pagosMensuales.total);
                    gastoTotal += parseFloat(dia.pagosPuntualesDia.total);
                    gastoTotal += parseFloat(dia.proveedores.total);


                    procesarPagos(dia.pagosAnuales,dataMes, 365); 
                    procesarPagos(dia.pagosPuntualesDia, dataMes);
                    procesarPagos(dia.pagosMensuales,dataMes, getDaysInMonth(fecha));       
                    procesarPagos(dia.envios, dataMes);
                    procesarPagos(pagosProveedores, dataMes);
                }
            });

            dataMes.totalCategorias = dataMes.categoriasCalculadas.reduce((acc, cat) => acc + cat.precio, 0);

            dataMes.categoriasCalculadas.forEach(data => {
                data.items.forEach(cat => {
                    cat.total = this.formatoEspanol(cat.total) + ' €';
                });
            });

          

            dataMes.datosResumenMes.gastoTotal = gastoTotal;
            dataMes.datosResumenMes.refundTotal = refundTotal;

            let gastoFacturas = 0;
            dataMes.dias.forEach(dia => {
                if(!dia.empty) gastoFacturas += parseFloat(dia.facturasNegativas.total);
            });
            dataMes.datosResumenMes.gastoFacturas = gastoFacturas;

            let gananciaFacturas = 0;
            dataMes.dias.forEach(dia => {
                if(!dia.empty) gananciaFacturas += parseFloat(dia.facturasPositivas.total);
            });
            dataMes.datosResumenMes.gananciaFacturas = gananciaFacturas;

            let gananciaTotal = 0;
            dataMes.dias.forEach(dia => {
                if(!dia.empty) {
                    dia.ingresos.items.forEach(item => {
                        gananciaTotal += parseFloat(item.total);
                    });
                }
            });
            gananciaTotal = parseFloat( gananciaTotal * this.libra_euro)
            dataMes.datosResumenMes.gananciaTotalDiaria = gananciaTotal;

            dataMes.datosResumenMes.total = gastoTotal + gananciaTotal + gastoFacturas + gananciaFacturas;

            //dataMes.datosResumenMes.cantidadDias = dataMes.dias.filter(dia => !dia.futuro).length;
            dataMes.datosResumenMes.cantidadDias = dataMes.dias.filter(dia => 'futuro' in dia && !dia.futuro).length;


            dataMes.datosResumenMes.gastoMedioDiaria = gastoTotal / dataMes.datosResumenMes.cantidadDias;
            dataMes.datosResumenMes.gananciaMediaDiaria = gananciaTotal / dataMes.datosResumenMes.cantidadDias;       
            
            
        },
        calcular(){
            function resetTime(date) {
                return new Date(date.getFullYear(), date.getMonth(), date.getDate());
            }

            function calcularTotal({
                    ingresos,
                    ordenes,
                    facturasPositivas,
                    ordenesRefund,
                    envios,
                    proveedores,
                    facturasNegativas,
                    pagosPuntualesDia,
                    pagosMensuales,
                    pagosAnuales,
                    euro_libra
                    }) {
                    let total = 0;

                    //console.log('--- Inicio cálculo total ---');
                    
                    // Ordenes: ya está en libras, no convertir
                    //console.log(`Ordenes (libras, sin conversión): ${ordenes.total.toFixed(2)}`);
                    total += ingresos.total;
                    //console.log(`Total después Ordenes: ${total.toFixed(2)}`);

                    // Función para convertir y mostrar
                    function convertirYSumar(nombre, valorEuros) {
                        const valorLibras = valorEuros * euro_libra;
                        //console.log(`${nombre} (euros): ${valorEuros.toFixed(2)} => (libras): ${valorLibras.toFixed(2)}`);
                        total += valorLibras;
                        //console.log(`Total después ${nombre}: ${total.toFixed(2)}`);
                    }

                    convertirYSumar('Facturas Positivas', facturasPositivas.total);
                    convertirYSumar('Envios', envios.total);
                    convertirYSumar('Proveedores', proveedores.total);
                    convertirYSumar('Facturas Negativas', facturasNegativas.total);
                    convertirYSumar('Pagos Puntuales', pagosPuntualesDia.total);
                    convertirYSumar('Pagos Mensuales', pagosMensuales.total);
                    convertirYSumar('Pagos Anuales', pagosAnuales.total);
                    convertirYSumar('Ordenes Refund', ordenesRefund.total);

                    //console.log('--- Cálculo total finalizado ---');
                    //console.log(`TOTAL FINAL: £${total.toFixed(2)}`);

                    return total;
                    }


            function normalizarFecha(fechaStr) {
                if (!fechaStr) return null;

                // Intentamos crear un objeto Date directamente
                let fecha = new Date(fechaStr);
                if (!isNaN(fecha)) return fecha.setHours(0, 0, 0, 0);

                // Si no es válida, probamos con formato DD-MM-YYYY
                const regexDMY = /^(\d{2})[-/](\d{2})[-/](\d{4})$/;
                const match = fechaStr.match(regexDMY);
                
                if (match) {
                    const [_, dia, mes, año] = match.map(Number);
                    return new Date(año, mes - 1, dia).setHours(0, 0, 0, 0);
                }

                return null; // No se pudo interpretar la fecha
            }

            let ordenes_total_price = 0;
            let ordenes_current_total_price = 0;

            //console.log(this.dias);
            this.dias.forEach(element => {
                if(element.empty)
                    return;
                element.total = 0;
                element.totalEur = 0;

                const fecha = new Date(element.Fecha);
                const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
                element.diaSemana = diasSemana[fecha.getDay()];
                element.diaNumero = fecha.getDate();

                const fechaSinHoras = new Date(element.Fecha).setHours(0, 0, 0, 0);

                element.desglosar = this.mostrarTodos;
                element.fijado = false;

                //Ordenes
                let ordenes = {total: 0, items:[]};
                this.items.find(item => {                    
                    if (item.created_at != null && item.created_at.split('T')[0] == element.Fecha && (this.empresaSeleccionada.nombre == 'Harber London' || this.empresaSeleccionada.nombre == 'Todas')) {
                        ordenes.total += parseFloat(item.current_total_price);

                        let curTotalPrice = parseFloat(item.current_total_price);
                        let TotalPrice = parseFloat(item.total_price);

                        /*item.refunds.forEach(itemRefund => {

                            if(itemRefund.transactions.length == 0){
                                itemRefund.refund_line_items.forEach(lineRefund => {
                                    ordenes.total -= parseFloat(lineRefund.subtotal_set.shop_money.amount);

                                    TotalPrice -= parseFloat(lineRefund.subtotal_set.shop_money.amount);

                                    ordenes_total_price -= parseFloat(lineRefund.subtotal_set.shop_money.amount);
                                    ordenes_current_total_price -= parseFloat(lineRefund.subtotal_set.shop_money.amount);
                                });

                            }

                        });*/
                        ordenes.items.push(item);

                        ordenes_total_price += parseFloat(item.total_price);
                        ordenes_current_total_price += parseFloat(item.current_total_price);

                    }
                });
            
                //Refunds
                let ordenesRefund = {total: 0, items:[]};
                this.items.find(item => {
                    let totalRefund = 0
                    let refundValido = false;

                    item.refunds.forEach(refund => {

                        if(refund.created_at.split('T')[0] == element.Fecha && (this.empresaSeleccionada.nombre == 'Harber London' || this.empresaSeleccionada.nombre == 'Todas')) {
                            if(refund.transactions.length > 0){
                                refund.transactions.forEach(lineRefund => {

                                    let amount = 0;

                                    if (lineRefund.currency != 'gbp' && lineRefund.currency != 'GBP')
                                    {
                                        if (lineRefund.receipt.balance_transaction != undefined && lineRefund.receipt.balance_transaction.exchange_rate != null)
                                            amount = parseFloat(lineRefund.amount) * lineRefund.receipt.balance_transaction.exchange_rate;
                                    }
                                    else
                                        amount = parseFloat(lineRefund.amount);
                                    
                                    if(amount > 0){
                                        ordenesRefund.total -= amount;
                                        refundValido = true;
                                        totalRefund += amount;
                                    }
                                        
                                });
                                
                            }
                        }
                    });

                    item.totalRefund = totalRefund;

                    if(refundValido)
                    {
                        ordenesRefund.items.push(item);
                    }
                    
                });

                //Ingresos
                let ingresos = {total: 0, items:[]};
                this.allIngresos.find(item => {
                    if (item.fecha == element.Fecha && (this.empresaSeleccionada.nombre == 'Harber London' || this.empresaSeleccionada.nombre == 'Todas')) {
                        ingresos.total += parseFloat(item.total);
                        ingresos.items.push(item);
                    }
                });                
                
                //Proveedores
                let proveedores = {total: 0, items:[]};
                this.allProveedores.find(item => {
                    if (item.fechaPagado == element.Fecha && (item.nombreEmpresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas')) {
                        proveedores.total -= parseFloat(item.total);
                        proveedores.items.push(item);
                    }
                });
            
                //Facturas Negativas
                let facturasNegativas = {total: 0, items:[]};
                this.allFacturas.find(item => {
                    const esMismaFecha = item.fechaPagado == element.Fecha;
                    const esMismoCliente = item.idCliente == this.empresaSeleccionada.idCliente;
                    const esEmpresaSeleccionadaTodas = this.empresaSeleccionada.nombre == 'Todas';
                    const esClientePermitido = item.cliente == "Craft Lab SL" || item.cliente == "Harber London Ltd";

                    if (esMismaFecha && (esMismoCliente || (esEmpresaSeleccionadaTodas && esClientePermitido))) {
                            facturasNegativas.total -= parseFloat(item.total);
                            facturasNegativas.items.push(item);
                    }
                });

                //Facturas Positivas
                let facturasPositivas = {total: 0, items:[]};
                this.allFacturas.find(item => {
                    const esMismaFecha = item.fechaPagado == element.Fecha;
                    const esEmpresaSeleccionadaTodas = this.empresaSeleccionada.nombre == 'Todas';
                    const esMismaEmpresa = item.idEmpresa == this.empresaSeleccionada.id;

                    if (esMismaFecha && (esEmpresaSeleccionadaTodas || esMismaEmpresa)) {
                        facturasPositivas.total += parseFloat(item.total);
                        facturasPositivas.items.push(item);
                    }
                });

                //Pagos puntuales
                let pagosPuntualesDia = {total: 0, totalEuro: 0, totalLibra: 0, totalDolar:0, items:[]};
                this.allPagos.find(item => {
                  
                    let fechaInicioPago = normalizarFecha(item.fecha);

                    if (fechaInicioPago == fechaSinHoras && item.tipoGasto == 'puntual' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas')) {
                        if(item.moneda == 'Euro')
                            pagosPuntualesDia.totalEuro -= parseFloat(item.precio);
                        else if(item.moneda == 'Libra')
                            pagosPuntualesDia.totalLibra -= parseFloat(item.precio);
                        else
                            pagosPuntualesDia.totalDolar -= parseFloat(item.precio);

                            pagosPuntualesDia.items.push(item);
                    }
                });

                 //Envios
                 let envios = {total: 0, items:[]};
                 this.allPagos.find(item => {
                  
                    let fechaInicioPago = normalizarFecha(item.fecha);

                    if (fechaInicioPago == fechaSinHoras && item.tipoGasto == 'envios' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas')) {
                        envios.total -= parseFloat(item.precio);
                        envios.items.push(item);
                    }
                });
                /*this.allEnvios.find(item => {
                    if (item.full_data.date.split(' ')[0] == element.Fecha && (this.empresaSeleccionada.nombre == 'Craft Lab' || this.empresaSeleccionada.nombre == 'Todas')) {
                        if (item.full_data.service != undefined && item.full_data.service.split(" | ")[1].replace("€", "") != "?"){                            
                            envios.total -= parseFloat(item.full_data.service.split(" | ")[1].replace("€", ""));
                            envios.items.push(item);
                        }
                    }
                });*/


                pagosPuntualesDia.total += pagosPuntualesDia.totalEuro;
                pagosPuntualesDia.total += pagosPuntualesDia.totalLibra * this.libra_euro;
                pagosPuntualesDia.total += pagosPuntualesDia.totalDolar * this.dolar_euro;

                function getDaysInMonth(date) {
                    const year = date.getFullYear();
                    const month = date.getMonth() + 1; // getMonth() es base 0, sumamos 1
                    return new Date(year, month, 0).getDate(); // Día 0 del mes siguiente es el último del actual
                }

                let fechaReset = resetTime(fecha);

                //Pagos mensuales
                let pagosMensuales = {total: 0, totalEuro: 0, totalLibra: 0, totalDolar:0, items:[]};
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'mensual')
                    {
                        let fechaInicioPago = new Date(item.fechaInicio);
                        fechaInicioPago = resetTime(fechaInicioPago);
                        if(fechaReset >= fechaInicioPago)
                        {
                            let continuar = false;
                            if(item.fechaFin == "")
                                continuar = true
                            else{
                                let fechaFinPago = new Date(item.fechaFin);
                                fechaFinPago = resetTime(fechaFinPago);
                                if(fechaReset <= fechaFinPago)
                                    continuar = true;   
                            }

                            if(continuar)
                            {
                                if(item.tipoGasto == 'mensual' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                                {
                                    let precioDia = item.precio / getDaysInMonth(fecha);
                                    if(item.moneda == 'Euro')
                                        pagosMensuales.totalEuro -= parseFloat(precioDia);
                                    else if(item.moneda == 'Libra')
                                        pagosMensuales.totalLibra -= parseFloat(precioDia);
                                    else
                                        pagosMensuales.totalDolar -= parseFloat(precioDia);

                                    pagosMensuales.items.push(item);
                                }
                            }
                            
                        } 
                    }
                });

                //ADS - se suma al pago mensual
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'ads')
                    {
                        let fechaInicioPago = new Date(item.fecha);
                        fechaInicioPago = resetTime(fechaInicioPago);
                        fechaInicioPago.setDate(1);
                        
                        if(fechaReset >= fechaInicioPago)
                        {
                            let fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 1, 0);
                            fechaFinPago = resetTime(fechaFinPago);
                            
                            if(fechaReset <= fechaFinPago)
                            {                              
                                if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                                {
                                    let precioDia = item.precio / getDaysInMonth(fecha);
                                    if(item.moneda == 'Euro')
                                        pagosMensuales.totalEuro -= parseFloat(precioDia);
                                    else if(item.moneda == 'Libra')
                                        pagosMensuales.totalLibra -= parseFloat(precioDia);
                                    else
                                        pagosMensuales.totalDolar -= parseFloat(precioDia);

                                    pagosMensuales.items.push(item);
                                }
                            }

                        }
                        else{
                            /*if(item.nombre == "Google")
                            console.log(item.id + '-' + item.precio + ' | ' + item.fecha);*/
                        }
                    }
                });

                function parseDMY(fechaStr) {
                    const [dia, mes, año] = fechaStr.split("-");
                    return new Date(`${año}-${mes}-${dia}`); // formato ISO: YYYY-MM-DD
                }

                //Nomina - se suma al pago mensual
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'nomina')
                    {

                        let fechaInicioPago = new Date(item.fecha); // item.fecha = "31-03-2025"
                        fechaInicioPago = resetTime(fechaInicioPago);
                        fechaInicioPago.setDate(1);
                        fechaInicioPago.setMonth(fechaInicioPago.getMonth() + 1);

                        if(fechaReset >= fechaInicioPago)
                        {
                            

                            let fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 1, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            if(fechaReset <= fechaFinPago)
                            {
                                
                                if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                                {
                                    let precioDia = item.precio / getDaysInMonth(fecha);
                                    if(item.moneda == 'Euro')
                                        pagosMensuales.totalEuro -= parseFloat(precioDia);
                                    else if(item.moneda == 'Libra')
                                        pagosMensuales.totalLibra -= parseFloat(precioDia);
                                    else
                                        pagosMensuales.totalDolar -= parseFloat(precioDia);

                                    pagosMensuales.items.push(item);
                                }
                            }

                        }
                    }
                });

                //Impuestos mensuales - se suma al pago mensual
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'impuestos')
                    {
                        let fechaInicioPago;
                        let fechaFinPago;
                        let precioDia;

                        if(item.tipoCobroAnual == 'mensual'){
                            fechaInicioPago = new Date(item.fecha);
                            fechaInicioPago = resetTime(fechaInicioPago);
                            fechaInicioPago.setDate(1);

                            fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 1, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            precioDia = item.precio / getDaysInMonth(fecha);
                        }
                        else if(item.tipoCobroAnual == 'trimestral'){
                            fechaInicioPago = new Date(item.fecha);
                            fechaInicioPago = resetTime(fechaInicioPago);
                            //fechaInicioPago.setMonth(fechaInicioPago.getMonth() + 1);
                            fechaInicioPago.setDate(1);

                            fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 2, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            precioDia = item.precio / 90;
                        }
                        else if(item.tipoCobroAnual == 'semestral' ){
                            fechaInicioPago = new Date(item.fecha);
                            fechaInicioPago = resetTime(fechaInicioPago);
                            //fechaInicioPago.setMonth(fechaInicioPago.getMonth() + 1);
                            fechaInicioPago.setDate(1);

                            fechaFinPago = new Date(fechaInicioPago.getFullYear(), fechaInicioPago.getMonth() + 5, 0);
                            fechaFinPago = resetTime(fechaFinPago);

                            precioDia = item.precio / 180;
                        }

                        if(fechaReset >= fechaInicioPago && fechaReset <= fechaFinPago)
                        {              
                            if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                            {
                                
                                if(item.moneda == 'Euro')
                                    pagosMensuales.totalEuro -= parseFloat(precioDia);
                                else if(item.moneda == 'Libra')
                                    pagosMensuales.totalLibra -= parseFloat(precioDia);
                                else
                                    pagosMensuales.totalDolar -= parseFloat(precioDia);

                                item.precioDia = precioDia;
                                pagosMensuales.items.push(item);
                            }
                        }
                    }
                });


                pagosMensuales.total += pagosMensuales.totalEuro;
                pagosMensuales.total += (pagosMensuales.totalLibra * this.libra_euro);
                pagosMensuales.total += (pagosMensuales.totalDolar * this.dolar_euro);

                //Pagos anuales
                let pagosAnuales = {total: 0, totalEuro: 0, totalLibra: 0, totalDolar:0, items:[]};
                this.allPagos.find(item => {
                    if(item.tipoGasto == 'anual')
                    {
                        let continuarFecha = false;

                        let fechaInicioPago = "";
                        let fechaFinPago = "";

                        let fechaAnual = new Date(item.fecha);
                        if(item.tipoCobroAnual == 'natural'){
                            fechaInicioPago = new Date(fechaAnual.getFullYear(),1, 1);
                            fechaFinPago = new Date(fechaAnual.getFullYear(),12, 31);

                            if(fecha >= fechaInicioPago && fecha <= fechaFinPago)
                                continuarFecha = true;
                        }
                        else if(item.tipoCobroAnual == 'retrospectivo anterior'){
                            fechaInicioPago = new Date(fechaAnual);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() - 1);

                            if(fecha <= fechaInicioPago && fecha >= fechaFinPago)
                                continuarFecha = true;                          
                        }
                        else if(item.tipoCobroAnual == 'retrospectivo siguiente'){
                            fechaInicioPago = new Date(fechaAnual);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() + 1);

                            if(fecha >= fechaInicioPago && fecha <= fechaFinPago)
                                continuarFecha = true;
                        }

                        if(continuarFecha)
                        {
                            if(item.tipoGasto == 'anual' && (item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                            {
                                let precioDia = item.precio / 365;
                                if(item.moneda == 'Euro')
                                    pagosAnuales.totalEuro -= parseFloat(precioDia);
                                else if(item.moneda == 'Libra')
                                    pagosAnuales.totalLibra -= parseFloat(precioDia);
                                else
                                    pagosAnuales.totalDolar -= parseFloat(precioDia);

                                pagosAnuales.items.push(item);
                            }
                        }
                    }
                });

                 //Impuestos anuales - se suma al pago anual
                 this.allPagos.find(item => {
                    if(item.tipoGasto == 'impuestos')
                    {
                        let fechaInicioPago;
                        let fechaFinPago;

                       if(item.tipoCobroAnual == 'retrospectivo anterior'){

                            fechaInicioPago = new Date(item.fecha);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() - 1);
                        }
                        else if(item.tipoCobroAnual == 'retrospectivo siguiente'){
                            fechaInicioPago = new Date(item.fecha);
                            fechaFinPago = new Date(fechaInicioPago);
                            fechaFinPago = resetTime(fechaFinPago);
                            fechaFinPago.setFullYear(fechaFinPago.getFullYear() + 1);
                        }

                        if(fechaReset >= fechaInicioPago && fechaReset <= fechaFinPago)
                        {
                            if((item.empresa == this.empresaSeleccionada.nombre || this.empresaSeleccionada.nombre == 'Todas'))
                            {
                                let precioDia = item.precio / 365;
                                if(item.moneda == 'Euro')
                                    pagosAnuales.totalEuro -= parseFloat(precioDia);
                                else if(item.moneda == 'Libra')
                                    pagosAnuales.totalLibra -= parseFloat(precioDia);
                                else
                                    pagosAnuales.totalDolar -= parseFloat(precioDia);

                                pagosAnuales.items.push(item);
                            }
                        }
                    }
                });

                pagosAnuales.total += pagosAnuales.totalEuro;
                pagosAnuales.total += pagosAnuales.totalLibra * this.libra_euro;
                pagosAnuales.total += pagosAnuales.totalDolar * this.dolar_euro;               

                //Sumas                

                element.total = 0;


                const resultado = calcularTotal({
                    ingresos: { total: ingresos.total },
                    ordenes: { total: ordenes.total },
                    facturasPositivas: { total: facturasPositivas.total },
                    ordenesRefund: { total: ordenesRefund.total },
                    envios: { total: envios.total },
                    proveedores: { total: proveedores.total },
                    facturasNegativas: { total: facturasNegativas.total },
                    pagosPuntualesDia: { total: pagosPuntualesDia.total },
                    pagosMensuales: { total: pagosMensuales.total },
                    pagosAnuales: { total: pagosAnuales.total },
                    euro_libra: this.euro_libra
                });

                element.total = resultado;
                

                element.totalEur = element.total * this.libra_euro;

                //Redondear
                ingresos.total = ingresos.total.toFixed(2);
                ordenes.total = ordenes.total.toFixed(2);
                envios.total = envios.total.toFixed(2);
                proveedores.total = proveedores.total.toFixed(2);
                facturasNegativas.total = facturasNegativas.total.toFixed(2);
                facturasPositivas.total = facturasPositivas.total.toFixed(2);
                element.total = element.total.toFixed(2);
                element.totalEur = element.totalEur.toFixed(2);
                pagosPuntualesDia.total = pagosPuntualesDia.total.toFixed(2);
                pagosMensuales.total = pagosMensuales.total.toFixed(2);
                pagosAnuales.total = pagosAnuales.total.toFixed(2);
                ordenesRefund.total = ordenesRefund.total.toFixed(2);

                element.ingresos = ingresos;
                element.ordenes = ordenes;
                element.envios = envios;
                element.proveedores = proveedores;
                element.facturasNegativas = facturasNegativas;
                element.facturasPositivas = facturasPositivas;
                element.pagosPuntualesDia = pagosPuntualesDia;
                element.pagosMensuales = pagosMensuales;
                element.pagosAnuales = pagosAnuales;
                element.ordenesRefund = ordenesRefund;

            });

            this.calcularResumen();

            

         

        },
        calcularResumen() {
            this.totalCategorias = 0;
            this.categoriasCalculadas = [];

            const getDaysInMonth = (date) => {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                return new Date(year, month, 0).getDate();
            };

            const calcularPrecio = (pago) => {
                let tasaCambio = 1;
                const moneda = pago.moneda?.toLowerCase().trim() || 'euro';
                if (moneda === 'libra') tasaCambio = this.libra_euro;
                else if (moneda !== 'euro'){ tasaCambio = this.dolar_euro};

                return (parseFloat(pago.precio) * tasaCambio);
            };

            const calcularPrecioDia = (pago) => {
                let tasaCambio = 1;
                const moneda = pago.moneda?.toLowerCase().trim() || 'euro';
                if (moneda === 'libra') tasaCambio = this.libra_euro;
                else if (moneda !== 'euro'){ tasaCambio = this.dolar_euro};
                
                return (parseFloat(pago.precioDia) * tasaCambio);
            };

            const procesarPagos = (pagos, divisor = 1) => {
                let total = 0;
                if (!pagos?.items) return;

                pagos.items.forEach(pago => {
                    let precioPago = 0;
                    if(pago.precioDia != undefined)
                        precioPago = calcularPrecioDia(pago);
                    else
                        precioPago = calcularPrecio(pago) / divisor;
                    let categoriaExistente = this.categoriasCalculadas.find(cat => cat.categoria === pago.categoria);

                    total+= precioPago;

                    if (!categoriaExistente) {
                        this.categoriasCalculadas.push({
                            categoria: pago.categoria,
                            precio: precioPago,
                            items: [{ nombre: pago.nombre, total: precioPago, pagos: [pago] }]
                        });
                    } else {
                        let itemExistente = categoriaExistente.items.find(item => item.nombre === pago.nombre);
                        if (itemExistente) {
                            itemExistente.total += precioPago;
                            itemExistente.pagos.push(pago);
                        } else {
                            categoriaExistente.items.push({
                                nombre: pago.nombre,
                                total: precioPago,
                                pagos: [pago]
                            });
                        }
                        categoriaExistente.precio += precioPago;
                    }
                });

                return total;

            };

            let gastoTotal = 0;
            let refundTotal = 0;

            this.dias.forEach(dia => {
                if (!dia.empty) {
                    const pagosProveedores = {
                        items: (dia.proveedores?.items || []).map(p => ({
                            categoria: "Proveedores",
                            nombre: p.proveedor,
                            precio: p.total,
                            moneda: "Euro"
                        }))
                    };

                    const fecha = new Date(dia.Fecha);

                    gastoTotal += parseFloat(dia.envios.total);
                    gastoTotal += parseFloat(dia.pagosAnuales.total);
                    gastoTotal += parseFloat(dia.pagosMensuales.total);
                    gastoTotal += parseFloat(dia.pagosPuntualesDia.total);
                    gastoTotal += parseFloat(dia.proveedores.total);


                    procesarPagos(dia.pagosAnuales, 365); 
                    procesarPagos(dia.pagosPuntualesDia);
                    procesarPagos(dia.pagosMensuales, getDaysInMonth(fecha));       
                    procesarPagos(dia.envios);
                    procesarPagos(pagosProveedores);
                }
            });

            this.totalCategorias = this.categoriasCalculadas.reduce((acc, cat) => acc + cat.precio, 0);

            this.categoriasCalculadas.forEach(data => {
                data.items.forEach(cat => {
                    cat.total = this.formatoEspanol(cat.total) + ' €'; // Para mostrar, no para calcular
                });
            });


            this.datosResumenMes.categoriasCalculadas = this.categoriasCalculadas;

            this.datosResumenMes.gastoTotal = gastoTotal;
            this.datosResumenMes.refundTotal = refundTotal;

            let gastoFacturas = 0;
            this.dias.forEach(dia => {
                if(!dia.empty) gastoFacturas += parseFloat(dia.facturasNegativas.total);
            });
            this.datosResumenMes.gastoFacturas = gastoFacturas;

            let gananciaFacturas = 0;
            this.dias.forEach(dia => {
                if(!dia.empty) gananciaFacturas += parseFloat(dia.facturasPositivas.total);
            });
            this.datosResumenMes.gananciaFacturas = gananciaFacturas;

            let gananciaTotal = 0;
            this.dias.forEach(dia => {
                if(!dia.empty){
                    dia.ingresos.items.forEach(item => {
                        gananciaTotal += parseFloat(item.total);
                    });
                } 
            });

            gananciaTotal = parseFloat( gananciaTotal * this.libra_euro)
            this.datosResumenMes.gananciaTotalDiaria = gananciaTotal;

            this.datosResumenMes.total = gastoTotal + gananciaTotal + gastoFacturas + gananciaFacturas;

            //this.datosResumenMes.cantidadDias = this.dias.filter(dia => !dia.futuro).length;
            this.datosResumenMes.cantidadDias = this.dias.filter(dia => 'futuro' in dia && !dia.futuro).length;


            this.datosResumenMes.gastoMedioDiaria = gastoTotal / this.datosResumenMes.cantidadDias;
            this.datosResumenMes.gananciaMediaDiaria = gananciaTotal / this.datosResumenMes.cantidadDias;            
            
            this.cargando = false;

            this.calcularGraficaCategorias();
            this.calcularGraficaOrdenesDia();
            this.calcularGraficaGastosDia();

            this.asociarChartsConMismoY();
        },
        calcularResumen2(){
            //datosResumenMes

            this.totalCategorias = 0;
            this.categoriasCalculadas = [];

            function getDaysInMonth(date) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1; // getMonth() es base 0, sumamos 1
                return new Date(year, month, 0).getDate(); // Día 0 del mes siguiente es el último del actual
            }

            const calcularPrecio = (pago) => {
                let tasaCambio = 1;
                if (pago.moneda === 'Libra') tasaCambio = this.libra_euro;
                else if (pago.moneda !== 'Euro') tasaCambio = this.dolar_euro;
                
                return parseFloat(pago.precio) * tasaCambio;
            };

            const procesarPagos = (pagos, divisor = 1) => {
                pagos.items.forEach(pago => {
                    let precioPago = calcularPrecio(pago) / divisor;

                    let categoriaExistente = this.categoriasCalculadas.find(cat => cat.categoria === pago.categoria);

                    if (!categoriaExistente) {
                        // Si la categoría no existe, la creamos con un objeto agrupador en items
                        this.categoriasCalculadas.push({
                            categoria: pago.categoria,
                            precio: precioPago,
                            items: [{ nombre: pago.nombre, total: precioPago, pagos: [pago] }]
                        });
                    } else {
                        // Buscar si el nombre ya existe en los items de la categoría
                        let itemExistente = categoriaExistente.items.find(item => item.nombre === pago.nombre);

                        if (itemExistente) {
                            // Si existe, sumamos el precio y agregamos el pago
                            itemExistente.total += precioPago;
                            itemExistente.pagos.push(pago);
                        } else {
                            // Si no existe, agregamos un nuevo grupo con el nombre
                            categoriaExistente.items.push({
                                nombre: pago.nombre,
                                total: precioPago,
                                pagos: [pago]
                            });
                        }

                        // Sumar al total de la categoría
                        categoriaExistente.precio += precioPago;
                    }
                });
            };

            //gastos
            let gastoTotal = 0;
            let refundTotal =0;
            this.dias.forEach(dia => {
                if(!dia.empty)
                {
                    const pagosProveedores = {
                            items: (dia.proveedores?.items || []).map(p => ({
                                categoria: "Proveedores",
                                nombre: p.proveedor,
                                precio: p.total,
                                moneda: "Euro" // o la que corresponda
                            }))
                        };

                    const fecha = new Date(dia.Fecha);

                    gastoTotal += parseFloat(dia.envios?.total || 0);
                    gastoTotal += parseFloat(dia.pagosAnuales.total);
                    gastoTotal += parseFloat(dia.pagosMensuales.total);
                    gastoTotal += parseFloat(dia.pagosPuntualesDia.total);
                    gastoTotal += parseFloat(dia.proveedores.total);
                    gastoTotal += parseFloat(dia.ordenesRefund.total);

                    refundTotal += parseFloat(dia.ordenesRefund.total);

                    procesarPagos(dia.pagosAnuales, 365);
                    procesarPagos(dia.pagosPuntualesDia);
                    procesarPagos(dia.pagosMensuales, getDaysInMonth(fecha));       
                    procesarPagos(dia.envios);
                    procesarPagos(pagosProveedores);

                }
            });

            this.categoriasCalculadas.forEach(cat => {
                this.totalCategorias += cat.precio;
            });

            this.categoriasCalculadas.forEach(data => {
                data.items.forEach(cat => {
                    cat.total = this.formatoEspanol(cat.total) + ' €';
                });
            });


            this.datosResumenMes.gastoTotal = parseFloat(gastoTotal).toFixed(2);
            this.datosResumenMes.refundTotal = parseFloat(refundTotal).toFixed(2);

            //Facturas negativas
            let gastoFacturas = 0;
            this.dias.forEach(dia => {
                if(!dia.empty)
                {
                    gastoFacturas += parseFloat(dia.facturasNegativas.total);
                }
            });
            this.datosResumenMes.gastoFacturas = parseFloat(gastoFacturas).toFixed(2);

            //Facturas positivas
            let gananciaFacturas = 0;
            this.dias.forEach(dia => {
                if(!dia.empty)
                {
                    gananciaFacturas += parseFloat(dia.facturasPositivas.total);
                }
            });
            this.datosResumenMes.gananciaFacturas = parseFloat(gananciaFacturas).toFixed(2);


            //Ganancias
            let gananciaTotal = 0;
            this.dias.forEach(dia => {
                if(!dia.empty)
                {
                    gananciaTotal += parseFloat(dia.ordenes.total*this.libra_euro);
                }
            });
            this.datosResumenMes.gananciaTotalDiaria = parseFloat(gananciaTotal).toFixed(2);

            this.datosResumenMes.total = parseFloat(gastoTotal + gananciaTotal + gastoFacturas + gananciaFacturas).toFixed(2);

            this.datosResumenMes.cantidadDias = this.dias.filter(dia => !dia.futuro).length;

            this.datosResumenMes.gastoMedioDiaria = (this.datosResumenMes.gastoTotal / this.datosResumenMes.cantidadDias).toFixed(2);
            this.datosResumenMes.gananciaMediaDiaria = (this.datosResumenMes.gananciaTotalDiaria / this.datosResumenMes.cantidadDias).toFixed(2);


        },
        formatModalAmount(val) {
            if (val === null || val === undefined) return '0,00 €';
            if (typeof val === 'string' && val.includes('€')) return val;
            return this.formatoEspanol(val) + ' €';
        },
        formatoEspanol(numero, decimales = 2) {
            if (numero === null || numero === undefined || isNaN(numero)) {
                return (0).toFixed(decimales).replace('.', ',');
            }

            const negativo = numero < 0 ? '-' : '';
            const [entero, decimal = ''] = Math.abs(numero).toFixed(decimales).split('.');

            // Poner puntos de miles
            const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            // Si decimales = 0 no añadimos la parte decimal
            return decimales > 0
                ? `${negativo}${enteroFormateado},${decimal}`
                : `${negativo}${enteroFormateado}`;
        },
        cambiarEmpresaSeleccionada(item){
            this.empresaSeleccionada.nombre = item;
            if(item === "Harber London")
            {
                this.empresaSeleccionada.id = 1;
                this.empresaSeleccionada.idCliente = 6;
            }                
            else if(item === "Craft Lab")
            {
                this.empresaSeleccionada.id = 2;
                this.empresaSeleccionada.idCliente = 0;
            }
            else
            {
                this.empresaSeleccionada.id = 0;
                this.empresaSeleccionada.idCliente = 0;
            }

            this.calcular();
        },   
        calcularGraficaCategorias() {
            // Asegúrate de que los datos estén disponibles
            if (!this.categoriasCalculadas || !Array.isArray(this.categoriasCalculadas)) return;

            const categoriasOrdenadas = this.categoriasCalculadas
                .slice()
                .sort((a, b) => b.precio - a.precio)
                .slice(0, 10);

            const total = categoriasOrdenadas.reduce((sum, cat) => sum + cat.precio, 0);

            const labels = categoriasOrdenadas.map(cat =>
                `${cat.categoria} (${this.formatoEspanol(cat.precio,0)}€)`
            );

            const series = categoriasOrdenadas.map(cat =>
                parseFloat(cat.precio.toFixed(0))
            );

            this.seriesCategorias = series;

            this.chartCategorias = {
                chart: {
                    type: "pie",
                    height: 350,
                },
                labels: labels,
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                    style: {
                        fontWeight: "bold",
                        colors: ["#ffffff"],
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `€${val}`;
                        },
                    },
                },
                stroke: {
                    width: 2,
                    colors: ["#fff"],
                },
                title: {
                    text: `Gastos por Categoría (€${total.toFixed(0)})`,
                    align: "middle",
                },
                legend: {
                    show: true,
                },
                colors: this.coloresGrafica, // Usa tu paleta personalizada si tienes
            };
        },
        calcularGraficaOrdenesDia() {
            // Asegúrate de que los datos estén disponibles
            if (!this.dias || !Array.isArray(this.dias)) return;

            const diasPasados = this.dias.filter(dia => !dia.futuro && !dia.empty).map(dia => {
                return {
                    fecha: dia.Fecha,
                    total: dia.ingresos.total * this.libra_euro // Convertimos a euros
                };
            });

            this.diasPasadosVentas = diasPasados;

            const total = diasPasados.reduce((sum, cat) => sum + cat.total, 0);

            this.totalChartDiaOrdenes = total.toFixed(0);

            const labels = diasPasados.map(cat => {
                const fecha = new Date(cat.fecha);
                const diaSemana = fecha.toLocaleDateString("es-ES", { weekday: "short" }); // ej: "lun"
                const dia = cat.fecha.split('-')[2]; // número de día

                return `${diaSemana} ${dia} (${cat.total.toFixed(0)}€)`;
            });

            this.labelsChartDiaOrdenes = labels;

            const series = diasPasados.map(cat =>
                parseFloat(cat.total.toFixed(0))
            );

            this.seriesDiaOrdenes =  [
            {
                name: "Ventas",
                data: series
            }
            ];



            
        },
        calcularGraficaGastosDia() {
            // Asegúrate de que los datos estén disponibles
            if (!this.dias || !Array.isArray(this.dias)) return;

            const diasPasados = this.dias
                .filter(dia => !dia.futuro && !dia.empty)
                .map(dia => {
                    const total = 
                    (Number(dia.envios?.total) || 0) +
                    (Number(dia.pagosMensuales?.total) || 0) +
                    (Number(dia.pagosAnuales?.total) || 0) +
                    (Number(dia.pagosPuntualesDia?.total) || 0) +
                    (Number(dia.ordenesRefund?.total) || 0) +
                    (Number(dia.proveedores?.total) || 0);

                    return {
                    fecha: dia.Fecha,
                    total: Math.abs(total) // 👈 convierte a positivo
                    };
                });


            this.diasPasadosGastos = diasPasados;


            const total = diasPasados.reduce((sum, cat) => sum + cat.total, 0);
            //console.log(total);
            this.totalChartDiaGastos = total.toFixed(0);

            const labels = diasPasados.map(cat => {
                const fecha = new Date(cat.fecha);
                const diaSemana = fecha.toLocaleDateString("es-ES", { weekday: "short" }); // ej: "lun"
                const dia = cat.fecha.split('-')[2];

                return `${diaSemana} ${dia} (${cat.total.toFixed(0)}€)`;
            });

            this.labelsChartDiaGastos = labels;

            const series = diasPasados.map(cat =>
                parseFloat(cat.total.toFixed(0))
            );

            this.seriesDiaGastos =  [
            {
                name: "Gastos",
                data: series
            },
            //this.seriesDiaOrdenes[0]
            ];

            
        },
        asociarChartsConMismoY(){
            
            const max = Math.ceil(Math.max(
                ...this.seriesDiaOrdenes.flatMap(s => s.data),
                ...this.seriesDiaGastos.flatMap(s => s.data)
                ) / 10) * 10;
                

            this.chartDiaOrdenes = {
                chart: {
                    type: "line",
                    height: 400,
                },
                labels: this.labelsChartDiaOrdenes,
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `€${val}`;
                        },
                    },
                },
                stroke: {
                    width: 2,
                    colors: ["#65ac68"],
                },
                title: {
                    text: `Ventas por dia ${this.mesSeleccionado.text} (${this.totalChartDiaOrdenes}€)`,
                    align: "middle",
                },
                legend: {
                    show: true,
                },
                yaxis: { min: 0, max },
                colors: ["#65ac68"],
            };

            this.chartDiaGastos = {
                chart: {
                    type: "line",
                    height: 400,
                },
                labels: this.labelsChartDiaGastos,
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `€${val}`;
                        },
                    },
                },
                stroke: {
                    //curve: 'stepline',
                    width: 3,
                    colors: ["#ff9a92", "#65ac68"],
                },
                title: {
                    text: `Gastos dia ${this.mesSeleccionado.text} (${this.totalChartDiaGastos}€)`,
                    //text: `Ventas / Gastos dia ${this.mesSeleccionado.text}`,
                    align: "middle",
                },
                legend: {
                    show: true,
                },
                yaxis: { min: 0, max },
                colors: ["#ff9a92", "#65ac68"], // Usa tu paleta personalizada si tienes
            };


            this.seriesDiaGastosVentas =  [
                this.seriesDiaOrdenes[0],    
                this.seriesDiaGastos[0],
                
            ];

            const labels = [];
            const labelColors = [];

            this.diasPasadosGastos.forEach((gastoDia, index) => {
                const fecha = new Date(gastoDia.fecha);
                const diaSemana = fecha.toLocaleDateString("es-ES", { weekday: "short" }); // ej: "lun"
                const numeroDia = gastoDia.fecha.split("-")[2];

                const ventaTotal = this.diasPasadosVentas[index]?.total || 0;
                const diferencia  = ventaTotal - gastoDia.total;    // nº positivo o negativo
                const etiqueta    = `${diaSemana} ${numeroDia} (${diferencia.toFixed(0)}€)`;

                labels.push(etiqueta);
                labelColors.push(diferencia < 0 ? "#e74c3c" : "#000");
            });

            this.chartDiaGastosVentas = {
                chart: {
                    type: "area",
                    height: 380,
                    toolbar: { show: false },
                    zoom: { enabled: false },
                    fontFamily: 'inherit',
                },
                colors: ["#34d399", "#f87171"],
                fill: {
                    type: "gradient",
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.35,
                        opacityTo: 0.05,
                        stops: [0, 95, 100],
                    },
                },
                stroke: {
                    width: 2.5,
                    curve: "smooth",
                },
                xaxis: {
                    categories: labels,
                    labels: {
                        rotate: -45,
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        style: {
                            colors: labelColors,
                            fontSize: '11px',
                        },
                        formatter: function (val) {
                            if (!val) return '';
                            return val.split(' (')[0];
                        },
                    },
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                    tooltip: { enabled: false },
                },
                yaxis: {
                    labels: {
                        style: { fontSize: '11px', colors: ['#9ca3af'] },
                        formatter: function (val) {
                            if (val >= 1000) return (val / 1000).toFixed(1) + 'k';
                            return val.toFixed(0);
                        },
                    },
                },
                grid: {
                    borderColor: '#f1f3f5',
                    strokeDashArray: 4,
                    xaxis: { lines: { show: false } },
                    padding: { left: 8, right: 8 },
                },
                dataLabels: { enabled: false },
                tooltip: {
                    shared: true,
                    intersect: false,
                    x: {
                        formatter: function (val, opts) {
                            return labels[opts.dataPointIndex] || val;
                        },
                    },
                    y: {
                        formatter: function (val) {
                            if (val === null || val === undefined) return '0 €';
                            return val.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
                        },
                    },
                },
                legend: {
                    show: true,
                    position: 'top',
                    horizontalAlign: 'right',
                    fontSize: '13px',
                    fontWeight: 500,
                    markers: { radius: 12 },
                    itemMargin: { horizontal: 12 },
                },
                title: {
                    text: `Ventas / Gastos — ${this.mesSeleccionado.text}`,
                    align: "left",
                    style: {
                        fontSize: '16px',
                        fontWeight: 700,
                        color: '#2c3e50',
                    },
                },
                markers: {
                    size: 0,
                    hover: { size: 5 },
                },
            };
        },
        obtenerUltimos12Meses(anio) {
            const hoy = new Date();
            const year = anio || this.anioSeleccionado || hoy.getFullYear();
            const meses = [];

            const mesMax = year === hoy.getFullYear() ? hoy.getMonth() : 11;

            for (let m = 0; m <= mesMax; m++) {
                const d = new Date(year, m);
                meses.push({
                    mes: d.toLocaleDateString('es-ES', { month: 'long' }).replace(/^\w/, c => c.toUpperCase()),
                    year: d.getFullYear(),
                    importe: '',
                    value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
                });
            }

            return meses;
        },
        cambiarAnio(anio) {
            this.anioSeleccionado = anio;
            this.mesesUltimos12 = this.obtenerUltimos12Meses(anio);
            this.recalcularMeses();
            const ultimoMes = this.mesesUltimos12[this.mesesUltimos12.length - 1];
            if (ultimoMes) {
                this.clickMes(ultimoMes);
            }
        },
        recalcularMeses() {
            this.mesesUltimos12 = this.mesesUltimos12.map((data) => {
                const mes = {value: data.value, data: [], dias: []};
                this.calcularMes(mes);
                return {
                    ...data,
                    data: mes.data,
                    datosResumenMes: mes.datosResumenMes,
                    dias: mes.dias,
                    importe: mes.datosResumenMes && mes.datosResumenMes.total ? mes.datosResumenMes.total : '',
                    totalCategorias: mes.datosResumenMes && mes.datosResumenMes.totalCategorias ? mes.datosResumenMes.totalCategorias : 0,
                    categoriasCalculadas: mes.categoriasCalculadas || [],
                };
            });
        },
        clickMes(fecha){
            const encontrado = this.opcionesMes.find(opt => opt.value === fecha.value);
            if (encontrado) {
                this.mesSeleccionado = encontrado;
            } else {
                this.mesSeleccionado = { value: fecha.value, text: fecha.mes + ' ' + fecha.year };
            }
        },
        openModalCategorias(){
            this.$bvModal.show('modal-categorias');
        },
        generarMeses() {
            const meses = [];
            const monthNames = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];

            const start = new Date(2025, 0, 1);
            const today = new Date();

            const startYear = start.getFullYear();
            const startMonth = start.getMonth();

            const endYear = today.getFullYear();
            const endMonth = today.getMonth();

            const diffMonths = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;
            const totalMonths = Math.min(diffMonths, 24);

            for (let i = 0; i < totalMonths; i++) {
                const date = new Date(startYear, startMonth + i, 1);
                const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                const text = `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
                meses.push({ value, text });
            }

            return meses;
        },
        toggleMes(valor) {
            const index = this.mesesSeleccionados.indexOf(valor);
            if (index >= 0) {
                this.mesesSeleccionados.splice(index, 1);
            } else {
                this.mesesSeleccionados.push(valor);
            }
        },

    },
    mounted() {    
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                   'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const hoy = new Date();
        const anioActual = hoy.getFullYear();
        const mesActual = hoy.getMonth() + 1;

        /*for (let y = anioActual; y >= anioActual - 2; y--) {
            for (let m = 12; m >= 1; m--) {
                // Evita meses futuros
                if (y === anioActual && m > mesActual) continue;

                const texto = `${meses[m - 1]} ${y}`;
                const valor = `${y}-${String(m).padStart(2, '0')}`;
                this.opcionesMes.push({value: valor, text: texto });
            }
        }

        this.mesSeleccionado = this.opcionesMes.find(opt => opt.value === `${anioActual}-${String(mesActual).padStart(2, '0')}`);*/

        this.opcionesMes = []; // Asegura que esté limpio

        const fechaInicio = new Date(2025, 0); // Noviembre es mes 10 (0-indexado)
        const fechaFin = new Date(anioActual, mesActual - 1); // Fecha del mes actual

        while (fechaFin >= fechaInicio) {
            const y = fechaFin.getFullYear();
            const m = fechaFin.getMonth() + 1;

            const texto = `${meses[m - 1]} ${y}`;
            const valor = `${y}-${String(m).padStart(2, '0')}`;

            this.opcionesMes.push({ value: valor, text: texto });

            // Retrocede un mes
            fechaFin.setMonth(fechaFin.getMonth() - 1);
        }

        this.mesSeleccionado = this.opcionesMes[0]      

        //this.loadItems();
        this.loadItemsSinShopify();
    },
    watch: {
        mesSeleccionado(newValue) {
            if(!this.primeraEjecucion)
                this.cargarDatosMes();
        },
    },
    computed: {
        aniosDisponibles() {
            const anioActual = new Date().getFullYear();
            const anios = [];
            for (let y = 2025; y <= anioActual; y++) {
                anios.push(y);
            }
            return anios;
        },
        modalAmountField() {
            if (!this.columnasDetails || this.columnasDetails.length === 0) return 'total';
            return this.columnasDetails[this.columnasDetails.length - 1].key;
        },
        modalTotal() {
            if (!this.diaDetail || this.diaDetail.length === 0) return 0;
            const key = this.modalAmountField;
            return this.diaDetail.reduce((acc, item) => {
                let raw = item[key];
                if (typeof raw === 'string') raw = raw.replace(/\./g, '').replace(',', '.').replace(/[^0-9.\-]/g, '');
                const val = parseFloat(raw || 0);
                return acc + (isNaN(val) ? 0 : val);
            }, 0);
        },
        textoFechaActual() {
            if (!this.mesSeleccionado?.value) return '';
            
            const [year, month] = this.mesSeleccionado.value.split('-');
            const nombresMeses = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];

            const mesNombre = nombresMeses[parseInt(month, 10) - 1];
            return `${mesNombre} ${year}`;
        }
    }  
};
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/vue-wizard.scss";
    @import "@core/scss/vue/libs/vue-select.scss";
</style>

<style scoped>
/* === GENERAL === */
.boton-detalles:hover {
    cursor: pointer;
}

/* === SELECTOR DE AÑO === */
.anio-selector-container {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
}
.anio-selector {
    display: inline-flex;
    background: #f1f3f5;
    border-radius: 10px;
    padding: 4px;
    gap: 4px;
}
.anio-btn {
    padding: 8px 24px;
    border: none;
    background: transparent;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease;
}
.anio-btn:hover {
    background: #e2e6ea;
}
.anio-btn.active {
    background: #fff;
    color: #2c3e50;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

/* === GRID DE MESES === */
.meses-grid {
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
    overflow-x: auto;
    padding-bottom: 4px;
}
.mes-card {
    flex: 1;
    min-width: 90px;
    padding: 14px 8px;
    text-align: center;
    background: #fff;
    border: 2px solid transparent;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.mes-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.mes-card--selected {
    border-color: #5b73e8;
    box-shadow: 0 4px 12px rgba(91,115,232,0.2);
}
.mes-card__nombre {
    font-size: 13px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 4px;
}
.mes-card--selected .mes-card__nombre {
    color: #5b73e8;
}
.mes-card__importe {
    font-size: 14px;
    font-weight: 700;
}
.text-success {
    color: #28a745 !important;
}
.text-danger {
    color: #dc3545 !important;
}

/* === SELECTOR DE EMPRESA === */
.empresa-selector-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.empresa-selector {
    display: inline-flex;
    background: #f1f3f5;
    border-radius: 10px;
    padding: 4px;
    gap: 4px;
}
.empresa-btn {
    padding: 6px 20px;
    border: none;
    background: transparent;
    border-radius: 8px;
    font-weight: 500;
    font-size: 13px;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease;
}
.empresa-btn:hover {
    background: #e2e6ea;
}
.empresa-btn.active {
    color: #fff;
    background: #f0ad4e;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.empresa-btn--harber.active {
    background: #5b73e8;
}
.empresa-btn--craft.active {
    background: #17a2b8;
}

/* === CARDS DE RESUMEN === */
.resumen-row {
    margin-bottom: 20px;
}
.resumen-card {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    overflow: hidden;
    margin-bottom: 16px;
    height: 100%;
}
.resumen-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 0;
}
.resumen-card__title {
    font-size: 16px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
}
.resumen-card__actions {
    display: flex;
    gap: 8px;
}
.icon-btn {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background: #f1f3f5;
    color: #495057;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    font-size: 13px;
}
.icon-btn:hover {
    background: #dee2e6;
}
.icon-btn--warning {
    background: #fff3cd;
    color: #856404;
}
.icon-btn--warning:hover {
    background: #ffe69c;
}
.resumen-card__body {
    padding: 16px 20px 20px;
}
.resumen-cols {
    display: flex;
    gap: 20px;
}
.resumen-col {
    flex: 1;
    padding: 12px;
    border-radius: 10px;
    background: #f8f9fa;
}
.resumen-col--gastos {
    border-left: 3px solid #dc3545;
}
.resumen-col--ganancias {
    border-left: 3px solid #28a745;
}
.resumen-col__title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #495057;
}
.resumen-col--gastos .resumen-col__title {
    color: #dc3545;
}
.resumen-col--ganancias .resumen-col__title {
    color: #28a745;
}
.resumen-col__item {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 13px;
    color: #495057;
}
.resumen-col__item strong {
    font-weight: 600;
}
.resumen-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 10px;
    background: #f1f3f5;
    font-size: 18px;
    font-weight: 700;
}
.resumen-total--positivo {
    background: #d4edda;
    color: #155724;
}
.resumen-total--negativo {
    background: #f8d7da;
    color: #721c24;
}

/* === CATEGORÍAS === */
.categorias-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}
.categoria-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    background: #f8f9fa;
    border-radius: 8px;
    font-size: 13px;
    transition: background 0.15s ease;
}
.categoria-item:hover {
    background: #e9ecef;
}
.categoria-item__nombre {
    font-weight: 600;
    color: #495057;
}
.categoria-item__precio {
    font-weight: 600;
    color: #2c3e50;
}

/* === GRID DE DÍAS === */
.dias-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 20px;
}
.dia-wrapper {
    flex: 0 0 calc(14.2857% - 6px);
    min-width: 120px;
}
.dia-card {
    border-radius: 12px;
    padding: 10px 12px;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.dia-card--positivo {
    background: linear-gradient(135deg, #56ab6a, #48a05b);
    color: #fff;
}
.dia-card--negativo {
    background: linear-gradient(135deg, #ef7b73, #e66b62);
    color: #fff;
}
.dia-card--futuro {
    background: #fff;
    color: #adb5bd;
    border: 1px dashed #dee2e6;
}
.dia-card--neutro {
    background: #fff;
    color: #495057;
    border: 1px solid #e9ecef;
}
.dia-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
}
.dia-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}
.dia-card__titulo {
    font-weight: 700;
    font-size: 14px;
}
.dia-card__titulo small {
    font-weight: 400;
    font-size: 11px;
    opacity: 0.8;
}
.dia-card__icon {
    font-size: 12px;
    opacity: 0.7;
    cursor: pointer;
}
.dia-card__icon:hover {
    opacity: 1;
}
.dia-card__importes {
    display: flex;
    justify-content: space-between;
    font-weight: 700;
    font-size: 13px;
}
.dia-card__desglose {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid rgba(255,255,255,0.25);
    font-size: 12px;
}
.dia-card--neutro .dia-card__desglose,
.dia-card--futuro .dia-card__desglose {
    border-top-color: #e9ecef;
}
.dia-card__linea {
    display: block;
    padding: 2px 0;
}
.dia-card__separator {
    height: 1px;
    background: rgba(255,255,255,0.2);
    margin: 4px 0;
}
.dia-card--neutro .dia-card__separator,
.dia-card--futuro .dia-card__separator {
    background: #e9ecef;
}

/* === GRÁFICA === */
.chart-container {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 20px;
    margin-bottom: 20px;
}

/* === CARGANDO === */
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}
.loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    color: #6c757d;
    font-weight: 500;
}
.loading-error {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 24px;
    background: #f8d7da;
    color: #721c24;
    border-radius: 10px;
    font-weight: 500;
}
.loading-error i {
    font-size: 20px;
}
</style>

<style>
/* Modal KPI - estilos globales porque b-modal renderiza fuera del componente */
.modal-detail-kpi .modal-content {
    border: none;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.15);
}
.modal-detail-kpi .modal-body {
    padding: 0;
}
.modal-kpi {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
}
.modal-kpi__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f1f3f5;
}
.modal-kpi__title {
    font-size: 17px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 2px;
}
.modal-kpi__count {
    font-size: 12px;
    color: #adb5bd;
    font-weight: 500;
}
.modal-kpi__close {
    width: 32px;
    height: 32px;
    border: none;
    background: #f1f3f5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #6c757d;
    font-size: 14px;
    transition: all 0.15s ease;
    flex-shrink: 0;
}
.modal-kpi__close:hover {
    background: #e9ecef;
    color: #343a40;
}
.modal-kpi__body {
    overflow-y: auto;
    padding: 8px 24px;
    flex: 1;
}
.modal-kpi__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f8f9fa;
    gap: 16px;
}
.modal-kpi__row:last-child {
    border-bottom: none;
}
.modal-kpi__row:hover {
    background: #f8f9fa;
    margin: 0 -24px;
    padding: 12px 24px;
    border-radius: 8px;
}
.modal-kpi__row-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}
.modal-kpi__row-name {
    font-weight: 600;
    font-size: 14px;
    color: #2c3e50;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.modal-kpi__row-desc {
    font-size: 12px;
    color: #868e96;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.modal-kpi__row-cat {
    display: inline-block;
    font-size: 11px;
    color: #5b73e8;
    background: #eef0fb;
    padding: 1px 8px;
    border-radius: 4px;
    font-weight: 500;
    width: fit-content;
}
.modal-kpi__row-notas {
    font-style: italic;
    color: #adb5bd;
}
.modal-kpi__row-amount {
    font-weight: 700;
    font-size: 14px;
    color: #2c3e50;
    white-space: nowrap;
    flex-shrink: 0;
}
.modal-kpi__row-amount--neg {
    color: #dc3545;
}
.modal-kpi__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #f8f9fa;
    border-top: 1px solid #f1f3f5;
    font-size: 16px;
}
.modal-kpi__footer span {
    font-weight: 500;
    color: #6c757d;
}
.modal-kpi__footer strong {
    font-size: 18px;
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// KPI — same tokens as /pedido-taller-vero/fabricando
// ══════════════════════════════════════════════════════════════

$kp-bg:        #F8FAFC;
$kp-surface:   #FFFFFF;
$kp-surface-2: #F1F5F9;
$kp-border:    #E2E8F0;
$kp-divider:   #EEF2F7;
$kp-ink:       #1E293B;
$kp-mute:      #64748B;
$kp-soft:      #94A3B8;
$kp-primary:   #3B82F6;
$kp-cta:       #F97316;
$kp-emerald:   #10B981;
$kp-coral:     #EF4444;
$kp-amber:     #F59E0B;

.kp {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background: $kp-bg;
  color: $kp-ink;
  margin: -2rem;
  padding: 28px 32px 56px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "tnum", "zero";

  *, *::before, *::after { box-sizing: border-box; }

  // ──────────── DASHBOARD HEADER ────────────
  .kp-dash-header {
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 14px;
    padding: 18px 20px 16px;
    margin-bottom: 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .kp-dash-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .kp-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $kp-primary;
    letter-spacing: 0.14em;
    margin-bottom: 4px;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: $kp-cta;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      animation: kp-pulse 2s infinite;
    }
  }

  .kp-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: $kp-ink;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0;
  }

  .kp-header-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .kp-stat-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 14px;
    background: $kp-bg;
    border: 1px solid $kp-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: $kp-mute;

    i { color: $kp-primary; font-size: 12px; }
    strong {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-weight: 700;
      color: $kp-ink;
      font-feature-settings: "tnum";
    }

    &--success {
      background: rgba(16, 185, 129, 0.06);
      border-color: rgba(16, 185, 129, 0.2);
      color: darken($kp-emerald, 8%);
      i { color: $kp-emerald; }
      strong { color: darken($kp-emerald, 8%); }
    }
    &--danger {
      background: rgba(239, 68, 68, 0.06);
      border-color: rgba(239, 68, 68, 0.2);
      color: $kp-coral;
      i { color: $kp-coral; }
      strong { color: $kp-coral; }
    }
  }

  .kp-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 38px;
    padding: 0 16px;
    background: $kp-primary;
    border: 1px solid $kp-primary;
    border-radius: 8px;
    color: #fff;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 200ms ease;

    i { font-size: 11px; }

    &:hover {
      background: darken($kp-primary, 6%);
      border-color: darken($kp-primary, 6%);
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
    }
  }

  // ──────────── ANIO SELECTOR ────────────
  .anio-selector-container {
    margin-bottom: 14px;
  }

  .anio-selector {
    display: inline-flex;
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 10px;
    padding: 4px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .anio-btn {
    height: 32px;
    padding: 0 16px;
    background: transparent;
    border: 0;
    border-radius: 7px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: $kp-mute;
    cursor: pointer;
    transition: all 150ms ease;

    &:hover { color: $kp-ink; }
    &.active {
      background: $kp-primary;
      color: #fff;
      box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25);
    }
  }

  // ──────────── EMPRESA SELECTOR ────────────
  .empresa-selector-container { margin-bottom: 14px; }

  .empresa-selector {
    display: inline-flex;
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 10px;
    padding: 4px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .empresa-btn {
    height: 32px;
    padding: 0 18px;
    background: transparent;
    border: 0;
    border-radius: 7px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: $kp-mute;
    cursor: pointer;
    transition: all 150ms ease;

    &:hover { color: $kp-ink; }
    &.active {
      background: $kp-ink;
      color: #fff;
    }
    &--harber.active { background: $kp-primary; }
    &--craft.active { background: $kp-cta; }
  }

  // ──────────── MESES GRID ────────────
  .meses-grid {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 18px;

    @media (max-width: 1100px) { grid-template-columns: repeat(6, 1fr); }
    @media (max-width: 600px) { grid-template-columns: repeat(3, 1fr); }
  }

  .mes-card {
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 10px;
    padding: 10px 12px 12px;
    cursor: pointer;
    transition: all 200ms ease;
    text-align: left;

    &:hover {
      border-color: $kp-primary;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
      transform: translateY(-1px);
    }

    &--selected {
      background: rgba(59, 130, 246, 0.06);
      border-color: $kp-primary;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
    }

    &--positivo { border-color: rgba(16, 185, 129, 0.4); }
    &--negativo { border-color: rgba(239, 68, 68, 0.4); }
  }

  .mes-card__nombre {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px;
    font-weight: 700;
    color: $kp-soft;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 4px;
  }

  .mes-card__importe {
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    font-weight: 700;
    color: $kp-ink;
    line-height: 1.1;
    font-feature-settings: "tnum";

    &.text-success { color: $kp-emerald !important; }
    &.text-danger { color: $kp-coral !important; }
  }

  // ──────────── RESUMEN CARDS ────────────
  .resumen-row {
    margin-bottom: 14px;
  }

  .resumen-card {
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: hidden;
    height: 100%;
    margin-bottom: 14px;
  }

  .resumen-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px;
    border-bottom: 1px solid $kp-divider;
  }

  .resumen-card__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: $kp-ink;
    letter-spacing: -0.01em;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;

    &::before {
      content: '›';
      font-family: 'JetBrains Mono', monospace;
      font-size: 16px;
      font-weight: 800;
      color: $kp-primary;
    }
  }

  .resumen-card__actions { display: inline-flex; gap: 6px; }

  .icon-btn {
    width: 30px;
    height: 30px;
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 8px;
    color: $kp-mute;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 150ms ease;
    font-size: 11px;

    &:hover { background: $kp-surface-2; color: $kp-primary; border-color: $kp-primary; }

    &--warning {
      color: $kp-cta;
      &:hover { background: rgba(249, 115, 22, 0.08); border-color: $kp-cta; }
    }
  }

  .resumen-card__body { padding: 16px 18px; }

  .resumen-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 12px;
  }

  .resumen-col {
    padding: 10px 12px;
    border: 1px solid $kp-divider;
    border-radius: 10px;
    background: $kp-bg;

    &--gastos { border-color: rgba(239, 68, 68, 0.18); background: rgba(239, 68, 68, 0.03); }
    &--ganancias { border-color: rgba(16, 185, 129, 0.18); background: rgba(16, 185, 129, 0.03); }
  }

  .resumen-col__title {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9.5px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin: 0 0 8px;
    color: $kp-mute;
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
  .resumen-col--gastos .resumen-col__title { color: $kp-coral; }
  .resumen-col--ganancias .resumen-col__title { color: $kp-emerald; }

  .resumen-col__item {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 4px 0;
    border-bottom: 1px dashed rgba(15, 23, 42, 0.06);
    font-size: 11px;
    color: $kp-mute;

    &:last-child { border-bottom: 0; }

    strong {
      font-family: 'JetBrains Mono', monospace;
      font-size: 12px;
      font-weight: 700;
      color: $kp-ink;
      font-feature-settings: "tnum";
    }
  }

  .resumen-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    background: $kp-surface-2;
    border-radius: 10px;
    margin-top: 8px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 600;
    color: $kp-mute;
    text-transform: uppercase;
    letter-spacing: 0.1em;

    strong {
      font-size: 16px;
      font-weight: 700;
      color: $kp-ink;
      font-feature-settings: "tnum";
    }

    &--positivo {
      background: rgba(16, 185, 129, 0.08);
      color: darken($kp-emerald, 8%);
      strong { color: $kp-emerald; }
    }
    &--negativo {
      background: rgba(239, 68, 68, 0.08);
      color: $kp-coral;
      strong { color: $kp-coral; }
    }
  }

  // ──────────── CATEGORIAS ────────────
  .categorias-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    margin-bottom: 8px;
  }

  .categoria-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    background: $kp-bg;
    border: 1px solid $kp-divider;
    border-radius: 8px;
    cursor: pointer;
    transition: all 150ms ease;

    &:hover {
      background: rgba(59, 130, 246, 0.04);
      border-color: $kp-primary;
    }

    &__nombre {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 11px;
      font-weight: 600;
      color: $kp-mute;
    }

    &__precio {
      font-family: 'JetBrains Mono', monospace;
      font-size: 12px;
      font-weight: 700;
      color: $kp-ink;
      font-feature-settings: "tnum";
    }
  }

  // ──────────── DIAS GRID ────────────
  .dias-grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 18px;
  }

  .dia-card {
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 10px;
    padding: 10px;
    transition: all 200ms ease;

    &:hover { border-color: $kp-soft; box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04); }

    &--positivo { border-color: rgba(16, 185, 129, 0.4); }
    &--negativo { border-color: rgba(239, 68, 68, 0.4); }
    &--neutro { opacity: 0.55; }
    &--futuro { background: $kp-surface-2; opacity: 0.45; }
  }

  .dia-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;

    .dia-card__icon {
      color: $kp-soft;
      font-size: 9px;
      cursor: pointer;
      &:hover { color: $kp-primary; }
    }

    .dia-card__titulo {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 12px;
      font-weight: 700;
      color: $kp-ink;

      small {
        font-family: 'JetBrains Mono', monospace;
        font-size: 9px;
        color: $kp-soft;
        text-transform: uppercase;
        margin-left: 3px;
      }
    }
  }

  .dia-card__importes {
    display: flex;
    flex-direction: column;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 600;
    color: $kp-ink;
    font-feature-settings: "tnum";
  }

  .dia-card__desglose {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid $kp-divider;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .dia-card__linea {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9.5px;
    color: $kp-mute;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    i { font-size: 8px; }
    b { color: $kp-ink; margin-left: auto; }
    &:hover { color: $kp-primary; b { color: $kp-primary; } }
  }

  .dia-card__separator {
    height: 1px;
    background: $kp-divider;
    margin: 4px 0;
  }

  // ──────────── CHART ────────────
  .chart-container {
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 14px;
    padding: 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    margin-bottom: 18px;
  }

  // ──────────── LOADING ────────────
  .loading-container {
    background: $kp-surface;
    border: 1px solid $kp-border;
    border-radius: 14px;
    padding: 60px;
    text-align: center;
    margin-top: 14px;

    .loading-spinner, .loading-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      color: $kp-mute;
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 13px;
    }

    .loading-error i {
      font-size: 32px;
      color: $kp-coral;
    }
  }

  @keyframes kp-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }
}

// ══════════ DARK MODE ══════════
.dark-layout .kp {
  background: #161616;
  color: #d0d2d6;

  .kp-dash-header,
  .resumen-card,
  .chart-container,
  .loading-container { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .kp-title, .kp-stat-pill strong, .resumen-card__title, .mes-card__importe, .resumen-col__item strong, .resumen-total strong { color: #e4e6eb; }
  .kp-stat-pill { background: #161616; border-color: #2c2c2c; }
  .resumen-card__header { border-bottom-color: #2c2c2c; }
  .anio-selector, .empresa-selector { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .mes-card { background: #1f1f1f; border-color: #2c2c2c; }
  .mes-card:hover { border-color: $kp-primary; }
  .resumen-col { background: #161616; border-color: #2c2c2c; }
  .resumen-total { background: #161616; }
  .categoria-item { background: #161616; border-color: #2c2c2c; }
  .dia-card { background: #1f1f1f; border-color: #2c2c2c; }
}
</style>